// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
html,
body {
  background-color: #222222;
  overflow: hidden;
  font-family: "Nunito", sans-serif;
  margin: 0px;
  padding: 0px;
  height: 100%;
}

.layout {
  display: flex;
  height: 100vh; /* Pour que la mise en page prenne toute la hauteur de la fenêtre */
}

.content {
  height: 100vh;
  flex-grow: 1;
  padding: 0px;
  color: red;
}

.login-container {
  background-color: #222222;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* pour occuper toute la hauteur de l'écran */
}

.login-image {
  width: 200px;
  margin-bottom: 20px;
}

.home-page {
  height: 100%;
  width: 100%;
  display: flex;
  /* Ajout de la propriété flexbox */
}

.main-box-document {
  display: flex;
  height: 100%;
  gap: 44px;
  width: 100%;
  padding-left: 42px;
  padding-right: 42px;
  padding-top: 32px;
  flex-direction: column;
  color: white;
}

.top-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-title {
  font-size: 24px;
  color: white;
}

.add-button {
  background-color: #007BFF;
  color: white;
  padding: 15px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}

.add-button:hover {
  background-color: #0056b3;
}

.search-bar-wrapper {
  display: flex;
  align-items: center;
  background-color: #2A2A2A;
  border-radius: 100px;
  padding: 10px;
}

.search-bar {
  flex-grow: 1;
  /* Prend toute la largeur restante */
  padding: 10px;
  border-radius: 100px;
  border: none;
  font-size: 17px;
  color: #FFFFFF;
  background-color: #2A2A2A;
  outline: none;
  /* Retire le contour bleu par défaut */
}

.search-icon {
  color: #FFFFFF;
}

.document-box {
  background-color: #333333;
  border-radius: 10px;
  padding: 15px;
  gap: 20px;
  display: flex;
  justify-content: space-between;
  color: white;
  margin-bottom: 15px;
  width: 100%; /* Ensure full width by default */
  box-sizing: border-box; /* Prevent overflow */
}

.Document-text-container {
  display: flex;
  gap: 8px;
}

.end-part-document {
  gap: 60px;
  display: flex;
}

.Document-Icon-container {
  display: flex;
  gap: 8px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* Fond semi-transparent pour l'overlay */
  display: flex;
  justify-content: center;
  align-items: center;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

.close-button:hover {
  background: none;
}

.modal-title {
  font-weight: 700;
  font-size: 25px;
  line-height: 34.1px;
  color: white;
  text-align: center;
  margin-bottom: 20px;
}

.home-documentList {
  list-style-type: none;
  padding: 0;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  overflow-y: auto;
}

.document-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 500px;
  padding: 10px;
  overflow-y: auto; /* Enable scrolling when content overflows */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.document-container::-webkit-scrollbar {
  display: none; /* Hide scrollbar in WebKit browsers */
}

.document-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #444;
  padding: 10px;
  border-radius: 10px;
  text-align: center;
}

.document-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
}

.document-container {
  display: flex;
  flex-wrap: wrap; /* Permet de revenir à la ligne si l'espace est insuffisant */
  gap: 10px;
  max-height: 500px; /* Limite la hauteur du conteneur pour forcer le défilement */
  overflow-y: auto; /* Rendre le conteneur scrollable verticalement */
  padding: 10px;
  /* Masquer la barre de scroll */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE et Edge */
}

.document-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari et Opera */
}

.document-preview {
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: none; /* Couleur de fond pour les documents */
}

.upload-button {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: #444;
  padding: 10px;
  border-radius: 10px;
  width: 150px;
  height: 150px;
}

.upload-icon {
  width: 50px;
  height: 50px;
}

.document-content {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.modal-content {
  width: 90%; /* Adjusts to 90% of the screen width */
  max-width: 1078px; /* Ensures it doesn't go beyond 1078px */
  height: 725px;
  max-height: 90vh; /* Maximum height at 90% of the viewport */
  background-color: #333333;
  border-radius: 15px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  overflow-y: auto; /* Allows scrolling if content overflows */
}

.upload-submit-button {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.upload-submit-button:hover {
  background-color: #45a049;
}

.box-container {
  background-color: #2a2a2a; /* Dark background for contrast */
  padding: 20px; /* Padding inside the box */
  border-radius: 10px; /* Rounded corners */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
  display: flex;
  flex-direction: column;
  align-items: center; /* Center content horizontally */
  margin-bottom: 20px; /* Space below the box */
  color: white; /* Text color */
  max-width: 80%; /* Restrict width */
  width: 100%;
  margin: auto; /* Center horizontally */
}

/* Optional title styling */
.box-container h3 {
  margin-bottom: 15px;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
}

@media (max-width: 1024px) {
  .main-box-document {
    max-width: 400px;
  }
  .document-box {
    flex-direction: column; /* Stack elements vertically on smaller screens */
    padding: 10px; /* Reduce padding for small screens */
    gap: 15px; /* Reduce space between elements */
  }
  .Document-text-container {
    justify-content: center; /* Center content when stacked */
  }
  .end-part-document {
    flex-direction: column; /* Stack the right-side elements vertically */
    gap: 10px; /* Adjust gap for smaller screens */
  }
}
@media (max-width: 768px) {
  .modal-content {
    width: 90%; /* Smaller width for tablets and below */
    padding: 15px;
  }
  .upload-submit-button {
    padding: 8px 16px; /* Smaller padding for smaller screens */
    font-size: 14px; /* Smaller font size */
    margin-bottom: 20px;
  }
  .document-box {
    padding: 10px; /* Reduce padding further for very small screens */
    gap: 10px; /* Reduce the gap between elements */
  }
  .Document-text-container {
    font-size: 14px; /* Reduce font size for smaller screens */
  }
  .document-Name {
    font-size: 16px; /* Adjust document name size */
    text-align: center; /* Center-align text */
  }
  .end-part-document {
    gap: 8px; /* Reduce gap between date and icons */
  }
  .Document-Icon-container {
    justify-content: center; /* Center icons */
  }
}
@media (max-width: 475px) {
  .main-box-document {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 10px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
    overflow-y: auto; /* Enable vertical scrolling */
    max-height: 100vh; /* Ensure the height does not exceed the viewport */
  }
  .document-box {
    padding: 20px; /* Further reduce padding for mobile */
    gap: 8px; /* Reduce gap */
    height: auto;
  }
  .document-Name {
    font-size: 14px; /* Smaller font size for very small screens */
    text-align: center; /* Center-align text */
  }
  .Document-text-container {
    justify-content: center;
  }
  .end-part-document {
    gap: 5px; /* Tighten gap on smaller screens */
  }
}
.document-detail {
  display: flex;
  height: 100vh;
  width: 100vw;
}

.back-button {
  position: fixed;
  top: 20px;
  left: 275px;
  z-index: 100;
  /* Ensure it's above other content */
  cursor: pointer;
}

.back-button img {
  width: 32px;
  height: 32px;
}

.file-display {
  display: flex;
  align-items: center;
  margin-top: 80px;
}

.document-pdf {
  padding-left: 20px;
  width: 500px;
  height: 600px;
  border: none;
  object-fit: cover;
  /* Ensure the document scales well */
}

.document-info {
  font-size: 14px;
  margin: auto 15% auto 2%;
  padding-right: 100px;
  max-width: 500px; /* Maximum width for document info */
  overflow-y: auto; /* Allow vertical scrolling */
  flex-grow: 1; /* Allow this section to grow and take up remaining space */
  padding-bottom: 50px; /* Add some padding to the bottom */
  max-height: 90%;
}

.header {
  display: flex;
  justify-content: space-between;
  /* Aligns file name and size */
  align-items: center;
  /* Vertically aligns items */
  margin-bottom: 20px;
}

.header div {
  margin-bottom: 0;
  /* Removes extra space between items */
}

.document-fields {
  display: flex; /* Change to flex to allow wrapping */
  flex-direction: column; /* Stack items vertically */
  gap: 10px; /* Space between items */
}

.field-row {
  display: flex;
  flex-wrap: wrap; /* Allow wrapping for long text */
  justify-content: space-between; /* Keep the label and value apart */
}

.field-label {
  text-transform: lowercase;
  font-size: 16px;
  color: #8f8f8f;
  flex: 0 0 30%; /* Adjusts the label width */
}

.field-value {
  font-size: 16px;
  color: #ffffff;
  flex: 1 1; /* Allow the value to take the remaining space */
  min-width: 100px; /* Optional: Set a minimum width to prevent the value from being too small */
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Positions one button on the left and the other on the right */
  margin-top: 20px;
  width: 100%;
  /* Make sure the buttons span the full width of the parent container */
}

button {
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  border: none;
}

.delete-button {
  background-color: #ff4d4f;
  color: white;
}

.change-button {
  background-color: #4caf50;
  color: white;
}

button:hover {
  opacity: 0.8;
}

.add-Button-tag {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  align-items: center;
}

.add-Button-tag-icon {
  width: 24px; /* Taille de l'icône */
  height: 24px;
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
}

.add-Button-tag:hover {
  background: none;
}

.Trash-Button-tag {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  align-items: center;
}

.Trash-Button-tag:hover {
  background: none;
}

.file-display-img {
  width: 500px;
  height: 600px; /* Maintain aspect ratio */
  object-fit: cover; /* Ensure the image scales properly */
}

@media (max-width: 1200px) {
  .document-pdf {
    width: 300px; /* Change width to 80% for medium-sized screens */
    height: 400px; /* Allow height to adjust automatically */
    padding-left: 10px; /* Reduce padding on smaller screens */
  }
  .file-display-img {
    width: 300px;
    height: 400px; /* Maintain aspect ratio */
    object-fit: cover; /* Ensure the image scales properly */
  }
}
@media (max-width: 768px) {
  .document-pdf {
    width: 300px; /* Change width to 80% for medium-sized screens */
    height: 400px; /* Allow height to adjust automatically */
    padding-left: 5px; /* Further reduce padding */
  }
  .document-info {
    padding-right: 10px;
  }
  .file-display-img {
    width: 300px;
    height: 400px; /* Maintain aspect ratio */
    object-fit: cover; /* Ensure the image scales properly */
  }
}
@media (max-width: 480px) {
  .document-pdf {
    width: 100%; /* Full width on very small screens */
    width: 100px; /* Change width to 80% for medium-sized screens */
    height: 200px; /* Allow height to adjust automatically */
    padding-left: 0; /* Remove padding */
  }
  .document-info {
    padding-right: 10px;
  }
  .file-display-img {
    width: 300px;
    height: 400px; /* Maintain aspect ratio */
    object-fit: cover; /* Ensure the image scales properly */
  }
  .back-button {
    left: 10px;
  }
}
.profile-page {
  height: 100%;
  width: 100%;
  display: flex;
}

.profile-container {
  display: flex;
  height: 100%;
  gap: 20px;
  width: 100%;
  padding-left: 42px;
  padding-right: 42px;
  padding-top: 32px;
  flex-direction: column;
  color: white;
}

.profile-info-container {
  background-color: #333333;
  padding: 30px;
  border-radius: 10px;
  display: flex;
  gap: 20px;
  color: white;
  flex-direction: column;
  /* Added flex-grow to ensure it takes available space */
}

.profile-info-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.information-text {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

/* Apply styles to the labels */
.info-row strong {
  text-transform: lowercase;
  font-size: 16px;
  color: #8f8f8f;
  min-width: 150px; /* Adjust if needed */
}

.downArrow {
  height: 24px;
  width: 24px;
}

.downArrowBtn {
  background-color: #333333;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  color: white;
}

.myInfo-text {
  flex-grow: 1;
  font-size: 20px;
  line-height: 27px;
}

/* Modifier button styling */
.button-container {
  display: flex; /* Flexbox for button alignment */
  justify-content: flex-end; /* Aligns button to the right */
}

.modifier-button {
  padding: 10px 20px; /* Add padding for better button size */
  background-color: #007BFF; /* Button background color */
  color: white; /* Button text color */
  border: none; /* Remove default border */
  border-radius: 5px; /* Rounded corners */
  cursor: pointer; /* Pointer cursor on hover */
  font-size: 16px; /* Font size */
}

.profile-logout-button {
  padding: 10px 20px; /* Add padding for better button size */
  background-color: red; /* Button background color */
  color: white; /* Button text color */
  border: none; /* Remove default border */
  border-radius: 5px; /* Rounded corners */
  cursor: pointer; /* Pointer cursor on hover */
  font-size: 16px; /* Font size */
}

.button-container {
  display: flex; /* Flexbox for button alignment */
  justify-content: flex-end; /* Align buttons to the right */
  gap: 10px; /* Space between buttons */
}

.annuler-button {
  padding: 10px 20px; /* Add padding for better button size */
  background-color: red; /* Red background for Annuler */
  color: white; /* White text color */
  border: none; /* Remove default border */
  border-radius: 5px; /* Rounded corners */
  cursor: pointer; /* Pointer cursor on hover */
  font-size: 16px; /* Font size */
}

.modifier-button {
  padding: 10px 20px; /* Add padding for better button size */
  background-color: #007BFF; /* Button background color */
  color: white; /* Button text color */
  border: none; /* Remove default border */
  border-radius: 5px; /* Rounded corners */
  cursor: pointer; /* Pointer cursor on hover */
  font-size: 16px; /* Font size */
}

.info-row input {
  margin-left: 10px; /* Add space between label and input */
  padding: 5px; /* Add padding for better input appearance */
  border: 1px solid #ccc; /* Border for the input */
  border-radius: 5px; /* Rounded corners */
  color: black; /* Text color */
  background-color: white; /* Background color */
}

.lastActivitySideBar {
  height: 100%;
  width: 100%;
  max-width: 312px;
  background-color: #333333;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding-top: 54px;
  padding-right: 24px;
  padding-left: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: white;
  margin-left: 44px;
}

.lastActivityTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.lastActivitySideBar ul {
  list-style-type: none; /* Remove default bullets */
  padding: 0; /* Remove default padding */
  margin: 0; /* Remove default margin */
}

.lastActivitySideBar li {
  position: relative; /* Positioning for the bar */
  padding-left: 20px; /* Space for the bar */
  margin-bottom: 10px; /* Space between list items */
}

.lastActivitySideBar li:before {
  content: ""; /* Create a pseudo-element for the bar */
  position: absolute; /* Position it absolutely */
  left: 0; /* Align it to the left */
  top: 0; /* Start from the top */
  height: 100%; /* Full height of the list item */
  width: 1px; /* Width of the bar */
  background-color: white; /* Color of the bar */
}

.lastActivitySideBar li:after {
  content: ""; /* Create a pseudo-element for the dot */
  position: absolute; /* Position it absolutely */
  left: -3px; /* Align it to the left of the bar */
  top: 0; /* Align it to the top of the list item */
  width: 8px; /* Width of the dot */
  height: 8px; /* Height of the dot */
  background-color: white; /* Color of the dot */
  border-radius: 50%; /* Make it circular */
}

.date-text {
  font-size: 12px; /* Adjust size as needed */
  color: #8f8f8f; /* Optional: change color for the date */
}

/* Tablettes et petits ordinateurs (jusqu'à 1024px) */
/* Tablettes en mode portrait et smartphones en paysage (jusqu'à 768px) */
/* Smartphones en portrait (jusqu'à 480px) */
@media (max-width: 480px) {
  .lastActivitySideBar {
    display: none;
  }
  .profile-container {
    margin-right: 42px;
    width: 100%; /* Ensure it takes the full width */
    overflow-y: auto; /* Add vertical scroll if the content exceeds screen height */
    height: 85vh; /* Set the height to the viewport height to make it scrollable */
  }
  .info-row {
    display: block;
  }
}
.langue-container {
  display: flex; /* Use flexbox for layout */
  justify-content: space-between; /* Space between 'langue :' and flags */
  align-items: center; /* Align vertically to the center */
  width: 100%; /* Ensure it takes the full width of the parent container */
}

.langue-flags {
  display: flex; /* Display flags in a row */
  gap: 10px; /* Space between flags */
}

.flag-icon {
  width: 24px; /* Flag size */
  height: 24px;
  border-radius: 50%; /* Optional: Make flags circular */
  object-fit: cover; /* Ensure flags fit properly */
  cursor: pointer; /* Pointer cursor for interactivity */
  transition: transform 0.2s; /* Hover effect */
}

.flag-icon:hover {
  transform: scale(1.1); /* Slightly enlarge on hover */
}

.twofa-container {
  display: flex; /* Use flexbox for layout */
  justify-content: space-between; /* Space between '2FA' and buttons */
  align-items: center; /* Align vertically to the center */
  width: 100%; /* Ensure it takes the full width of the parent container */
  margin-top: 2%;
}

.twofa-options {
  display: flex; /* Display buttons in a row */
  gap: 10px; /* Space between buttons */
}

.twofa-button {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  color: white;
  background-color: #007BFF; /* Default blue for enabled state */
  transition: background-color 0.3s ease;
}

.twofa-button.disable {
  background-color: #FF4B4B; /* Red for disabled state */
}

.twofa-button:hover {
  opacity: 0.9;
}

.page {
  background-color: #222222;
  height: 100vh;
  margin: 0;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  overflow-y: auto;
}

.title {
  font-size: 2rem;
  font-weight: bold;
  margin: 2% 0 20px;
}

.txt {
  font-size: 1rem;
  margin: 4% 0 10px;
}

.txtBis {
  font-size: 1rem;
  margin: 1% 0 20px;
}

.subscription-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}

.subscription {
  background-color: #333333;
  margin: 10px;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 300px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 300px;
}
.subscription.selected {
  background-color: rgb(76.5, 76.5, 76.5);
}
.subscription.slide-in-left {
  animation: slide-in-left 1s ease-out;
}
.subscription.slide-in-right {
  animation: slide-in-right 1s ease-out;
}

.price {
  font-size: 1.5rem;
  margin: 10px 0 20px;
}

.divider {
  width: 50%;
  margin: auto;
  margin-bottom: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.advantages-container {
  background-color: #333333;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 300px;
  margin: 0 auto;
  width: 100%;
}

.button {
  background-color: #007BFF;
  border: none;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
  margin-right: 5px;
}
.button:hover {
  background-color: rgb(0, 98.4, 204);
}

.confirm-button {
  display: flex;
  justify-content: flex-end;
  font-size: 1rem;
  padding: 10px 20px;
  background-color: #007BFF;
  color: white;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s, box-shadow 0.3s;
}
.confirm-button:hover {
  background-color: rgb(0, 98.4, 204);
}

.cross-button {
  position: absolute;
  top: 20px;
  left: 20px;
  font-size: 1.5rem;
  cursor: pointer;
}

@keyframes slide-in-right {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slide-in-left {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
@media (max-width: 768px) {
  .title {
    font-size: 1.5rem;
    margin: 2% 0 15px;
  }
  .txt {
    font-size: 0.9rem;
    margin: 4% 0 8px;
  }
  .txtBis {
    font-size: 0.9rem;
    margin: 1% 0 15px;
  }
  .subscription {
    max-width: 250px;
    margin: 10px;
  }
  .confirm-button {
    font-size: 0.9rem;
    padding: 8px 15px;
  }
}
@media (max-width: 480px) {
  .subscription {
    max-width: 100%;
    margin: 10px 0;
  }
  .txt {
    font-size: 0.8rem;
    margin: 3% 0 6px;
  }
  .txtBis {
    font-size: 0.8rem;
    margin: 1% 0 10px;
  }
  .confirm-button {
    font-size: 0.8rem;
    padding: 6px 12px;
  }
}
.login-box {
  background-color: #333333;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 50px 20px 50px;
  border-radius: 15px;
  flex-direction: column;
  gap: 10px;
  width: 80%; /* Default width */
  max-width: 400px; /* Ensures the login box doesn't grow too large */
  margin: 0 auto; /* Centers the box horizontally */
}

.text-Connexion {
  font-size: 24px;
  color: white;
}

.signup-button {
  font-size: 13px;
  background: none;
  border: none;
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  padding: 0;
}
.signup-button:hover {
  color: #0056b3; /* Couleur au survol */
}

.signup-ForgetPassword {
  font-size: 13px;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: inherit;
  padding: 0;
}
.signup-ForgetPassword:hover {
  color: #0056b3; /* Couleur au survol */
}

.signup-text {
  color: white;
  size: 13px;
  font-size: 13px;
}

.signup-button:hover {
  color: #ddd;
}

/* styles.scss */
.connect-button {
  width: 400px; /* Largeur du bouton */
  height: 49px; /* Hauteur fixe du bouton */
  border-radius: 12px; /* Bordures arrondies */
  padding: 15px 20px; /* Espacement interne (padding) */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0E71D0; /* Couleur de fond (bleu par exemple) */
  color: white; /* Couleur du texte */
  font-size: 16px; /* Taille du texte */
  cursor: pointer; /* Curseur pointeur au survol */
  border: none; /* Pas de bordure */
  outline: none; /* Pas de contour */
}
.connect-button:hover {
  background-color: #0056b3; /* Changement de couleur au survol */
}

@media (min-width: 1440px) {
  .login-box {
    padding: 40px; /* Reduce padding on smaller screens */
  }
  .connect-button {
    font-size: 18px; /* Texte légèrement plus grand */
    padding: 18px 24px; /* Plus de padding pour un rendu plus espacé */
  }
}
/* Tablettes et petits ordinateurs */
@media (max-width: 1024px) {
  .login-box {
    width: 70%;
  }
  .connect-button {
    width: 300px; /* Réduction de la largeur pour les tablettes */
    font-size: 16px; /* Taille du texte standard */
    padding: 14px 18px;
  }
}
@media (max-width: 768px) {
  .login-box {
    padding: 30px; /* Reduce padding on smaller screens */
    width: 60%;
  }
  .connect-button {
    font-size: 15px; /* Texte plus petit */
    padding: 12px 16px;
  }
}
@media (max-width: 480px) {
  .login-box {
    padding: 20px;
    width: 70%;
  }
  .connect-button {
    width: 100%; /* Utilisation complète de la largeur de l'écran */
    font-size: 14px; /* Taille du texte réduite pour s'adapter aux petits écrans */
    padding: 10px 12px; /* Padding plus réduit pour un design plus compact */
    height: 44px;
  }
}
/* Modal overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8); /* Transparent black background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure the modal is on top */
}

/* Modal content */
.modal-content {
  background-color: #333333; /* Dark background */
  padding: 15px 20px; /* Reduced padding for a smaller height */
  border-radius: 15px;
  width: 90%;
  max-width: 400px;
  text-align: center;
  color: white; /* White text for contrast */
  display: flex;
  flex-direction: column;
  gap: 15px; /* Reduced space between elements */
  justify-content: center; /* Center the content vertically */
  align-items: center; /* Center the content horizontally */
  max-height: 400px; /* Limit the height of the modal */
  overflow-y: auto; /* Allow scrolling if content exceeds height */
}

/* Logo in the modal */
.modal-logo {
  max-width: 80px; /* Reduce the logo size */
  margin-bottom: 10px; /* Reduce space below the logo */
}

/* Modal input fields */
.modal-content .input {
  margin-bottom: 15px;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  width: 100%; /* Make inputs full-width */
}

.modal-content .connect-button {
  background-color: #0E71D0; /* Blue background */
  color: white;
  font-size: 16px;
  padding: 12px 20px;
  border-radius: 12px;
  cursor: pointer;
  border: none;
  outline: none;
  width: 100%;
  margin-bottom: 10px;
}

.modal-content .connect-button:hover {
  background-color: #0056b3; /* Darker blue on hover */
}

/* Close button */
.close-modal-button {
  background-color: #999999; /* Gray button for closing */
  color: white;
  font-size: 16px;
  padding: 12px 20px;
  border-radius: 12px;
  cursor: pointer;
  border: none;
  outline: none;
  width: 100%;
}

.close-modal-button:hover {
  background-color: #666666; /* Darker gray on hover */
}

.input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  font-size: 16px;
}

.password-requirements {
  text-align: left;
  padding: 0;
  list-style-type: none;
}

.password-requirements li {
  font-size: 14px;
  margin: 5px 0;
}

.password-requirements li.valid {
  color: green;
}

.password-requirements li.invalid {
  color: red;
}

.connect-button {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  margin-top: 10px;
  cursor: pointer;
}

.connect-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.error-message {
  color: red;
  margin-bottom: 10px;
}

.inputs-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px; /* Space between inputs */
}

@media (max-width: 376px) {
  .login-box {
    max-height: 90vh; /* Limit the height to fit within the viewport */
    overflow-y: auto; /* Enable vertical scrolling */
    padding: 10px; /* Reduce padding for smaller screens */
    width: 90%; /* Adjust width for better fit */
  }
  .inputs-container {
    max-height: none; /* Remove height limit for smaller screens */
    overflow-y: visible; /* Ensure inputs are fully visible */
  }
  .connect-button {
    font-size: 14px; /* Smaller text for smaller screens */
    padding: 8px 10px; /* Compact padding */
    width: 100%; /* Full width */
  }
}
.scrollable-container {
  max-height: 400px; /* Adjust this height to fit your design */
  overflow-y: auto; /* Enable vertical scrolling */
  width: 100%;
}

.input {
  border-radius: 15px;
  padding-top: 14px;
  padding-right: 20px;
  padding-bottom: 14px;
  padding-left: 20px;
  background-color: #e7e7e8;
  display: flex;
  align-items: center;
  width: 100%; /* On utilise 100% par défaut pour une meilleure adaptabilité */
  box-sizing: border-box;
  border: 1px solid #ccc;
  font-size: 16px;
  outline: none;
  max-width: 400px; /* Largeur maximale pour les grands écrans */
  height: 48px;
}

/* Grands écrans (à partir de 1440px) */
@media (min-width: 1440px) {
  .input {
    max-width: 500px; /* Augmentation de la largeur pour les grands écrans */
    font-size: 18px; /* Texte légèrement plus grand */
    padding: 16px 24px; /* Plus de padding pour plus de confort visuel */
  }
}
/* Tablettes et petits ordinateurs (jusqu'à 1024px) */
@media (max-width: 1024px) {
  .input {
    max-width: 300px; /* Réduction de la largeur pour s'adapter aux tablettes */
    font-size: 16px; /* Taille de texte légèrement réduite */
  }
}
/* Tablettes en mode portrait et smartphones en paysage (jusqu'à 768px) */
@media (max-width: 768px) {
  .input {
    font-size: 15px; /* Texte plus petit */
  }
}
/* Smartphones en portrait (jusqu'à 480px) */
@media (max-width: 480px) {
  .input {
    max-width: 100%; /* Utilisation complète de la largeur de l'écran */
    font-size: 14px; /* Taille de texte réduite pour les petits écrans */
    height: 44px; /* Hauteur réduite pour économiser de l'espace */
    padding: 12px 16px; /* Moins de padding pour un design plus compact */
  }
}
.resend-button {
  font-size: 15px;
  background: none;
  border: none;
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  padding: 0;
}
.resend-button:hover {
  color: #0056b3;
  /* Couleur au survol */
}

.resend-text {
  color: white;
  font-size: 15px;
  word-wrap: break-word;
  /* Permet au texte de se couper s'il est trop long */
  line-height: 1.5;
  /* Espace entre les lignes */
  margin-bottom: 15px;
}

/* Styles pour le conteneur d'entrée du code */
.code-input-container {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  /* Espacement entre chaque boîte */
  margin-bottom: 20px;
}

/* Style des boîtes d'entrée */
.code-input-box {
  width: 50px;
  height: 50px;
  text-align: center;
  font-size: 24px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-sizing: border-box;
  outline: none;
}

.code-input-box:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

/* Style pour le bouton */
button {
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 8px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

@media (max-width: 480px) {
  .code-input-box {
    width: 30px;
    height: 30px;
  }
}
/* Sidebar container */
.sidebar {
  display: flex;
  flex-direction: column; /* Stack items vertically */
  justify-content: space-between; /* Push content to edges */
  height: 100%; /* Full height */
  background-color: #1C1C1C;
  color: white;
  padding-top: 40px;
  padding-left: 16px;
  padding-right: 16px;
}

/* Logo styling */
.logo {
  text-align: center;
}
.logo .logo-image {
  width: 200px;
  height: auto;
  margin-bottom: 20px;
}

.logo-btn {
  background-color: transparent;
}

.logo-btn:hover {
  background-color: transparent; /* Ensures the background remains the same on hover */
  cursor: default; /* Optional: Change the cursor to default on hover */
}

/* Navigation links */
.nav-links {
  list-style: none;
  padding: 0;
  width: 100%;
}
.nav-links li {
  width: 100%;
  margin-bottom: 20px;
}
.nav-links li .nav-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 15px;
  background: none;
  border: none;
  color: white; /* Default text color */
  text-align: left;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
}
.nav-links li .nav-button img {
  margin-right: 10px;
  width: 24px;
  height: 24px;
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%); /* Default icon color (#333333) */
}
.nav-links li .nav-button:hover {
  background-color: #444;
}
.nav-links li .nav-button.active {
  background-color: #333; /* Fond pour le bouton actif */
}

/* Divider */
.sidebar-divider {
  width: 228px;
  border: 1px solid rgba(151, 151, 151, 0.3);
  /* Couleur et opacité de la ligne */
  padding-top: 40px 0;
  /* Espace autour de la ligne */
}

/* Responsive adjustments */
@media screen and (max-width: 768px) {
  .sidebar {
    display: none; /* Hide sidebar below 768px */
  }
  .mobile-nav {
    display: flex; /* Show mobile nav at 768px and below */
  }
}
/* Tablettes et petits ordinateurs (jusqu'à 1024px) */
@media (max-width: 1024px) {
  .sidebar .logo-image {
    width: 80px;
  }
  .sidebar-divider {
    width: 130px;
  }
}
.mobile-nav {
  display: none; /* Hidden by default */
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #1C1C1C;
  display: flex;
  justify-content: space-around;
  padding: 5px 0; /* Reduce padding to fit buttons */
  z-index: 1000;
  overflow-x: auto; /* Allow horizontal scrolling if needed */
}

.mobile-nav button {
  background: none;
  border: none;
  color: white;
  text-align: center;
  flex-direction: column; /* Stack icon and text vertically */
  display: flex;
  align-items: center; /* Center align items */
  flex-grow: 1; /* Allow buttons to take equal width */
  padding: 5px; /* Reduce padding to fit more buttons */
}

.mobile-nav img {
  width: 20px; /* Smaller icons */
  height: 20px;
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
}

.mobile-nav span {
  font-size: 10px; /* Smaller text */
  margin-top: 2px; /* Less space between icon and text */
  color: #999; /* Lighter text color */
}

/* Media query for phones (less than 480px) */
@media (max-width: 480px) {
  .sidebar {
    display: none; /* Hide the sidebar on phones */
  }
  .mobile-nav {
    display: flex; /* Show the mobile nav only on phones */
  }
}
@media (min-width: 769px) {
  .mobile-nav {
    display: none;
  }
}
/* Media queries for larger screens (tablet and desktop) */
.logout-button {
  margin-top: auto; /* Pushes the button to the bottom */
  padding: 15px;
  background-color: #e53935; /* Red color */
  color: white;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.3s;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.logout-button:hover {
  background-color: #c62828; /* Darker red on hover */
}

.logout-icon {
  width: 20px; /* Icon size */
  height: 20px;
  margin-right: 10px;
  filter: invert(1);
}

.DocumentSideBar {
  height: 100%;
  width: 100%;
  max-width: 312px;
  background-color: #333333;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding-top: 54px;
  padding-right: 24px;
  padding-left: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: white;
}

/* Tablettes et petits ordinateurs (jusqu'à 1024px) */
/* Tablettes en mode portrait et smartphones en paysage (jusqu'à 768px) */
/* Smartphones en portrait (jusqu'à 480px) */
@media (max-width: 480px) {
  .DocumentSideBar {
    display: none;
  }
}
.divider-document {
  width: 100%;
  border: 1px solid rgba(151, 151, 151, 0.3);
  margin-bottom: 0px;
}

.quickAccess {
  font-weight: 700;
  font-size: 24px;
  line-height: 32.74px;
  color: white;
}

.documentList {
  list-style-type: none;
  padding: 0;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  overflow-y: auto;
}

.documentItem {
  background-color: #222222; /* Couleur de fond */
  border-radius: 10px; /* Rayon des coins */
  padding: 15px; /* Padding interne */
  display: flex;
  justify-content: space-between; /* Sépare le texte à gauche et l'étoile à droite */
  align-items: center; /* Centre verticalement les éléments */
  color: white; /* Couleur du texte pour qu'il soit visible sur fond sombre */
  margin-bottom: 15px; /* Espace entre chaque item de fichier */
}

.documentInfo {
  display: flex;
  flex-direction: column; /* Permet d'afficher le nom au-dessus de la date */
}

.documentName {
  font-size: 17px;
  font-weight: bold;
}

.documentDate {
  font-size: 14px;
  color: #FFFFFF;
  margin-top: 5px; /* Espace entre le nom et la date */
  line-height: 19px;
}

.Favorite-container {
  display: flex;
  justify-content: center; /* Centrer le bouton horizontalement dans le conteneur */
  align-items: center; /* Centrer le bouton verticalement dans le conteneur */
}

.favoriButton:hover {
  background: none;
}

.containerwith-logo {
  display: flex;
  gap: 10px;
}

.documentIcon {
  margin-right: 10px; /* Espace entre le logo et le texte */
  align-self: flex-start; /* Aligne le logo en haut (pas centré) */
}

.favoriButton {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
}

.favoriIcon {
  width: 24px; /* Taille de l'icône */
  height: 24px;
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
}

.favoriButton:hover .favoriIcon {
  filter: invert(1) brightness(0.8) saturate(100%); /* Effet au survol, légèrement moins blanc */
}

.storageBox {
  background-color: #222222;
  border-radius: 10px;
  padding: 40px;
  gap: 20px;
  flex-direction: column;
  display: flex;
  color: white;
  position: relative;
}

.storageText {
  font-size: 20px;
  color: white;
}

.fileCount {
  font-size: 17px;
  color: white;
  position: relative;
  top: 15px;
}

.storageBarContainer {
  width: 100%; /* La barre occupe toute la largeur de son conteneur */
  height: 17px;
  background-color: #FFFFFF; /* Couleur de fond de la barre */
  border-radius: 100px;
  overflow: hidden; /* Pour que le débordement du contenu soit masqué */
}

.storageBar {
  height: 100%;
  background: #0E71D0 100%;
  border-radius: 100px;
  width: 0%; /* La largeur sera ajustée dynamiquement */
  transition: width 0.3s ease-in-out; /* Animation douce pour la mise à jour du pourcentage */
}

.storageInfo {
  display: flex;
  justify-content: space-between; /* Permet de les séparer ou utiliser 'flex-start' pour les aligner à gauche */
}

.textButton {
  background: none;
  text-decoration: underline;
  cursor: pointer;
  font-size: 16px; /* Taille du texte */
  padding: 0; /* Enlever le padding par défaut */
  align-self: flex-start; /* Cette propriété permet de l'aligner à gauche dans un conteneur flex */
}

.textButton:hover {
  background: none;
  color: #0056b3; /* Changement de couleur au survol */
  text-decoration: none; /* Enlever le soulignement au survol */
}

.modalOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modalContent {
  width: 80%; /* Default width */
  max-width: 600px; /* Limit the modal size */
  max-height: 80vh; /* Adjust height based on content */
  background: #333333;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center; /* Horizontally center */
  overflow-y: auto; /* Enable scrolling if content exceeds height */
}

.closeIcon {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.modalContent h2 {
  margin-bottom: 20px;
}

.modalContent p {
  margin-bottom: 10px;
}

@media (max-width: 1024px) {
  .storageBox {
    width: 200px;
  }
  .modalContent {
    width: 90%; /* Adjust modal width */
    max-width: 500px;
    padding: 15px; /* Reduce padding */
  }
}
@media (max-width: 768px) {
  .storageBox {
    width: 200px;
  }
  .modalContent {
    width: 95%; /* Almost full width */
    max-width: 400px;
    padding: 10px;
  }
  .modalContent h2 {
    font-size: 18px; /* Adjust header size */
  }
  .modalContent p {
    font-size: 14px; /* Adjust paragraph size */
  }
  .closeIcon {
    top: 5px;
    right: 5px;
    width: 20px;
    height: 20px;
  }
}
.offer-Container {
  background-color: #333333;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 40px;
  padding-bottom: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* Pour espacer les flèches et le texte */
  gap: 20px;
  /* Espace entre les éléments */
  color: white;
  /* Texte en blanc */
}

.arrow-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0px;
}

.arrow-button:hover {
  background-color: transparent;
  color: #222222;
}

.offer-text {
  flex-grow: 1;
  font-size: 20px;
  line-height: 27px;
}

.offer-box {
  gap: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.discover-button {
  background-color: #007BFF;
  color: white;
  padding: 15px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

@media (max-width: 475px) {
  .offer-Container {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
}
.index-scenario-main-page {
  height: 100%;
  width: 100%;
  display: flex;
}

.scenarios-container {
  flex-grow: 1; /* Allow it to grow and fill the available space */
  overflow-y: auto; /* Enable vertical scrolling */
  max-height: calc(100vh - 100px); /* Adjust max height based on header/button height */
}

.index-scenario-page {
  height: 100%;
  gap: 44px;
  width: 100%;
  padding-left: 42px;
  padding-right: 42px;
  padding-top: 32px;
  flex-direction: column;
  display: flex;
  color: white;
}

.index-scenario-top-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.index-scenario-add-button {
  background-color: #007BFF;
  color: white;
  padding: 15px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}

.index-scenario-add-button:hover {
  background-color: #0056b3;
}

/* Existing styles here... */
/* Grid layout for the cards */
.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); /* Automatically adjust to fit */
  gap: 40px;
  margin-bottom: 80px;
  justify-content: center; /* Ensure the cards are centered */
}

/* Card container */
.card-scenario {
  width: 100%; /* Make the card width responsive */
  max-width: 532px; /* Maximum width for larger screens */
  background-color: #2e2e2e; /* Dark background */
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card-image {
  width: 100%;
  height: 200px; /* Set a fixed height */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0; /* Optional: add a background color for images that don't fill the area */
}

.card-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* Ensure the image fits within the dimensions and maintains aspect ratio */
}

/* Card content (title and description) */
.card-content {
  padding: 16px;
  color: #fff;
  flex-grow: 1; /* Allow content to fill remaining space */
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Align items at the start */
}

/* Title and paragraph styling */
.card-content h3 {
  margin: 0; /* Remove default margin */
  font-size: 1.25em;
}

.card-content p {
  margin: 8px 0 0; /* Add margin for spacing */
  font-size: 0.9em;
  color: #a0a0a0;
}

/* Responsive Styles */
@media (max-width: 768px) {
  /* For tablets and smaller devices */
  .card-grid {
    grid-template-columns: 1fr; /* 1 card per row */
  }
  .card-scenario {
    margin: 0 auto; /* Center the card */
    width: 90%; /* Adjust width */
    max-width: none; /* Remove max-width to allow more flexibility */
  }
  .card-content h3 {
    font-size: 1.1em; /* Reduce font size for smaller screens */
  }
  .card-content p {
    font-size: 0.85em; /* Reduce font size for smaller screens */
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  /* For small laptops */
  .card-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); /* Adjust to fill available space */
  }
}
@media (min-width: 1025px) {
  /* For larger screens */
  .card-grid {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)); /* Adjust to fill available space */
  }
}
.scenarioDetail-delete-button {
  background-color: #FF4B4B; /* Red color */
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.scenarioDetail-delete-button:hover {
  background-color: #D94444; /* Slightly darker red for hover effect */
  opacity: 0.9;
}

.scenarioDetail-main-page {
  height: 100%;
  width: 100%;
  display: flex;
}

.scenarioDetail-page {
  height: 100%;
  gap: 44px;
  width: 100%;
  padding-left: 42px;
  padding-right: 42px;
  padding-top: 32px;
  flex-direction: column;
  display: flex;
  color: white;
}

.scenarioDetail-top-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-side {
  display: flex;
  align-items: center;
  gap: 10px;
}

.right-side {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* For the document container */
.scenario-detail-document-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 10px;
}

.document-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #2A2A2A;
  border-radius: 10px;
  padding: 20px;
}

.document-text {
  display: flex;
  flex-direction: column;
  color: white;
}

.document-title {
  font-size: 16px;
  font-weight: bold;
}

.document-description {
  font-size: 14px;
  color: #888888;
}

/* Status styles */
.valid {
  background-color: #37A169;
  color: white;
  padding: 8px 16px;
  border-radius: 12px;
}

.scenario-detail-upload-button {
  background-color: #007BFF;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
}

.scenario-detail-upload-button:hover {
  background-color: #0056b3;
}

.scenarioDetail-add-button {
  background-color: #37A169;
  color: white;
  padding: 15px 20px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  margin-left: 10px; /* Add some space between the buttons */
}

.scenarioDetail-add-button:hover {
  background-color: #37A169;
}

.scenarioDetail-add-button-dot {
  background-color: #474747;
  color: white;
  padding: 15px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  border-radius: 12px;
  margin-left: 10px; /* Add some space between the buttons */
}

.disclaimer-container {
  background-color: #222222;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative; /* Ensure child elements like buttons are positioned relative to this */
}

.language-buttons {
  position: absolute;
  top: 20px; /* Distance from the top */
  right: 20px; /* Distance from the right */
  display: flex;
  gap: 10px;
}

.language-button:hover {
  background-color: #222222;
}

.language-buttons:hover {
  background-color: #222222;
}

.language-button {
  background: none;
  border: none;
  cursor: pointer;
}

.language-button img {
  width: 24px;
  height: 24px;
}

.disclaimer-image {
  width: 150px;
  margin-bottom: 20px;
}

.disclaimer-box {
  background-color: #333333;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  border-radius: 15px;
  flex-direction: column;
  gap: 20px;
  width: 90%; /* Default width for smaller screens */
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
}

.disclaimer-title {
  font-size: 24px;
  color: white;
}

.disclaimer-text {
  font-size: 12px;
  color: white;
  line-height: 1.5;
}

/* Media queries */
@media (min-width: 768px) {
  .disclaimer-box {
    padding: 50px;
    width: 70%;
  }
  .disclaimer-image {
    width: 200px;
  }
  .disclaimer-title {
    font-size: 28px;
  }
  .disclaimer-text {
    font-size: 16px;
  }
}
@media (min-width: 1024px) {
  .disclaimer-box {
    width: 720px;
  }
  .disclaimer-title {
    font-size: 32px;
  }
  .disclaimer-text {
    font-size: 18px;
  }
}
*,
*::before,
*::after {
  box-sizing: border-box; /* Ensures padding and borders are included in the width */
}

.Newscenario-main-page {
  height: 100%;
  display: flex;
  flex-direction: column; /* Stack header and inputs vertically */
  padding: 20px;
}

.Newscenarioheader {
  display: flex;
  justify-content: space-between; /* Distribute items evenly */
  align-items: baseline;
}

.Newscenario-left-header {
  display: flex;
}

.text-item {
  color: white;
}

.text-item-header {
  color: white;
  margin-left: 10px;
  font-size: 24px;
  font-weight: bold;
}

.back-arrow {
  width: 24px;
  height: auto;
}

.check-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: green;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.check-icon {
  width: 16px;
  height: auto;
  filter: brightness(0) invert(1);
}

.Newscenario-form-container {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
}

.input-field, .dropdown-field {
  width: 100%; /* Makes both elements take full width */
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  color: black;
}

.input-field::placeholder, .dropdown-field {
  color: #aaa;
}

.plus-button {
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.plus-icon {
  width: 20px;
  height: auto;
}

.back-button {
  background: none; /* Remove background */
  border: none; /* Remove border */
  cursor: pointer; /* Make it clickable */
  padding: 0; /* Remove padding */
}

.back-arrow {
  width: 24px; /* Adjust size as needed */
  height: auto;
}

.dropdown-checkbox-container {
  display: flex;
  align-items: center;
  width: 100%; /* Full width to align with other inputs */
  gap: 10px;
}

.dropdown-field {
  flex: 1 1; /* Allow dropdown to expand */
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  color: black;
}

.checkbox-container {
  display: flex;
  align-items: center;
}

.checkbox-input {
  width: 24px; /* Increase width */
  height: 24px; /* Increase height */
  transform: scale(1.5); /* Scale up the checkbox */
  margin-right: 10px; /* Add some space from the dropdown */
}

.trash-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px; /* Optional: to give a rounded look on hover */
}

.trash-button:hover {
  background-color: red; /* Changes background to red on hover */
}

.trash-icon {
  width: 20px;
  height: auto;
  filter: brightness(0) invert(1);
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/styles/pages/login.scss","webpack://./src/styles/pages/Home.scss","webpack://./src/styles/pages/documentsDetail.scss","webpack://./src/styles/pages/profile.scss","webpack://./src/styles/pages/subscription.scss","webpack://./src/styles/components/loginBox.scss","webpack://./src/styles/components/input.scss","webpack://./src/styles/components/confirmMail.scss","webpack://./src/styles/components/ConfirmationBox.scss","webpack://./src/styles/components/Sidebar.scss","webpack://./src/styles/components/DocumentSideBar.scss","webpack://./src/styles/components/stockageContainer.scss","webpack://./src/styles/components/Offer.scss","webpack://./src/styles/components/Scenarios.scss","webpack://./src/styles/components/ScenarioDetail.scss","webpack://./src/styles/components/disclaimer.scss","webpack://./src/styles/components/NewScenarios.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;;EAEI,yBAAA;EACA,gBAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AACJ;;AAEA;EACE,aAAA;EACA,aAAA,EAAA,mEAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;AACF;;ACtBA;EACI,yBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,6CAAA;ADyBJ;;ACtBA;EACI,YAAA;EACA,mBAAA;ADyBJ;;AEtCA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EAEA,kCAAA;AFwCJ;;AErCA;EACI,aAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;AFwCJ;;AEnCA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AFsCJ;;AEnCA;EACI,eAAA;EACA,YAAA;AFsCJ;;AEnCA;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AFsCJ;;AEnCA;EACI,yBAAA;AFsCJ;;AElCA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,aAAA;AFqCJ;;AElCA;EACI,YAAA;EACA,oCAAA;EACA,aAAA;EACA,oBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,sCAAA;AFqCJ;;AElCA;EACI,cAAA;AFqCJ;;AElCA;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA,EAAA,iCAAA;EACA,sBAAA,EAAA,qBAAA;AFqCJ;;AElCA;EACI,aAAA;EACA,QAAA;AFqCJ;;AElCA;EACI,SAAA;EACA,aAAA;AFqCJ;;AElCA;EACI,aAAA;EACA,QAAA;AFqCJ;;AElCA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,yCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AFqCJ;;AEhCA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AFmCJ;;AEhCA;EACI,gBAAA;AFmCJ;;AEhCA;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AFmCJ;;AEjCA;EACI,qBAAA;EACA,UAAA;EACA,qBAAA,EAAA,YAAA;EACA,wBAAA,EAAA,0BAAA;EACA,gBAAA;AFoCJ;;AEjCA;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA,EAAA,4CAAA;EACA,qBAAA,EAAA,YAAA;EACA,wBAAA,EAAA,gBAAA;AFoCJ;;AElCE;EACE,aAAA,EAAA,sCAAA;AFqCJ;;AEnCA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AFsCJ;;AEnCA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AFsCJ;;AEnCA;EACI,aAAA;EACA,eAAA,EAAA,6DAAA;EACA,SAAA;EACA,iBAAA,EAAA,6DAAA;EACA,gBAAA,EAAA,iDAAA;EACA,aAAA;EAEA,+BAAA;EACA,qBAAA,EAAA,YAAA;EACA,wBAAA,EAAA,eAAA;AFqCJ;;AElCE;EACE,aAAA,EAAA,4BAAA;AFqCJ;;AElCE;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA,EAAA,uCAAA;AFqCJ;;AElCE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AFqCJ;;AElCE;EACE,WAAA;EACA,YAAA;AFqCJ;;AElCE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AFqCJ;;AEjCA;EACE,UAAA,EAAA,uCAAA;EACA,iBAAA,EAAA,wCAAA;EACA,aAAA;EACA,gBAAA,EAAA,0CAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA,EAAA,0CAAA;AFoCF;;AEjCA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AFoCF;;AEjCA;EACE,yBAAA;AFoCF;;AEhCE;EACE,yBAAA,EAAA,iCAAA;EACA,aAAA,EAAA,2BAAA;EACA,mBAAA,EAAA,oBAAA;EACA,wCAAA,EAAA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA,EAAA,gCAAA;EACA,mBAAA,EAAA,wBAAA;EACA,YAAA,EAAA,eAAA;EACA,cAAA,EAAA,mBAAA;EACA,WAAA;EACA,YAAA,EAAA,wBAAA;AFmCJ;;AEhCE,2BAAA;AACA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AFmCJ;;AEhCE;EACE;IACI,gBAAA;EFmCN;EEhCE;IACI,sBAAA,EAAA,iDAAA;IACA,aAAA,EAAA,qCAAA;IACA,SAAA,EAAA,kCAAA;EFkCN;EEhCE;IACI,uBAAA,EAAA,gCAAA;EFkCN;EEhCE;IACI,sBAAA,EAAA,6CAAA;IACA,SAAA,EAAA,mCAAA;EFkCN;AACF;AE/BA;EACI;IACE,UAAA,EAAA,wCAAA;IACA,aAAA;EFiCJ;EE9BE;IACE,iBAAA,EAAA,wCAAA;IACA,eAAA,EAAA,sBAAA;IACA,mBAAA;EFgCJ;EE9BE;IACI,aAAA,EAAA,kDAAA;IACA,SAAA,EAAA,oCAAA;EFgCN;EE7BE;IACI,eAAA,EAAA,yCAAA;EF+BN;EE5BE;IACI,eAAA,EAAA,8BAAA;IACA,kBAAA,EAAA,sBAAA;EF8BN;EE3BE;IACI,QAAA,EAAA,sCAAA;EF6BN;EE1BE;IACI,uBAAA,EAAA,iBAAA;EF4BN;AACF;AEzBE;EACE;IACI,aAAA;IACA,sBAAA;IACA,YAAA;IACA,SAAA;IACA,kBAAA;IACA,mBAAA;IACA,iBAAA;IACA,gBAAA,EAAA,8BAAA;IACA,iBAAA,EAAA,mDAAA;EF2BN;EEzBE;IACI,aAAA,EAAA,sCAAA;IACA,QAAA,EAAA,eAAA;IACA,YAAA;EF2BN;EEvBE;IACI,eAAA,EAAA,6CAAA;IACA,kBAAA,EAAA,sBAAA;EFyBN;EEtBE;IACI,uBAAA;EFwBN;EErBE;IACI,QAAA,EAAA,mCAAA;EFuBN;AACF;AGpYA;EAEE,aAAA;EACA,aAAA;EACA,YAAA;AHqYF;;AG9XA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;AHiYF;;AG9XA;EACE,WAAA;EACA,YAAA;AHiYF;;AG9XA;EAEE,aAAA;EAEA,mBAAA;EACA,gBAAA;AH+XF;;AGzXA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,oCAAA;AH4XF;;AGvXA;EACE,eAAA;EACA,wBAAA;EACA,oBAAA;EACA,gBAAA,EAAA,oCAAA;EACA,gBAAA,EAAA,6BAAA;EACA,YAAA,EAAA,2DAAA;EACA,oBAAA,EAAA,mCAAA;EACA,eAAA;AH0XF;;AGpXA;EACE,aAAA;EACA,8BAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;AHuXF;;AGpXA;EACE,gBAAA;EACA,sCAAA;AHuXF;;AGpXA;EACE,aAAA,EAAA,qCAAA;EACA,sBAAA,EAAA,2BAAA;EACA,SAAA,EAAA,wBAAA;AHuXF;;AGpXA;EACE,aAAA;EACA,eAAA,EAAA,iCAAA;EACA,8BAAA,EAAA,mCAAA;AHuXF;;AGpXA;EACE,yBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA,EAAA,4BAAA;AHuXF;;AGpXA;EACE,eAAA;EACA,cAAA;EACA,SAAA,EAAA,gDAAA;EACA,gBAAA,EAAA,4EAAA;AHuXF;;AGnXA;EACE,aAAA;EACA,8BAAA;EACA,gEAAA;EACA,gBAAA;EACA,WAAA;EACA,sEAAA;AHsXF;;AGnXA;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AHsXF;;AGlXA;EACE,yBAAA;EACA,YAAA;AHqXF;;AGlXA;EACE,yBAAA;EACA,YAAA;AHqXF;;AGlXA;EACE,YAAA;AHqXF;;AGlXA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;AHqXF;;AGlXA;EACE,WAAA,EAAA,sBAAA;EACA,YAAA;EACA,yHAAA;AHqXF;;AGlXA;EACE,gBAAA;AHqXF;;AGlXA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;AHqXF;;AGlXA;EACE,gBAAA;AHqXF;;AGlXA;EACE,YAAA;EACA,aAAA,EAAA,0BAAA;EACA,iBAAA,EAAA,qCAAA;AHqXF;;AGjXA;EACE;IACE,YAAA,EAAA,iDAAA;IACA,aAAA,EAAA,yCAAA;IACA,kBAAA,EAAA,sCAAA;EHoXF;EGjXA;IACE,YAAA;IACA,aAAA,EAAA,0BAAA;IACA,iBAAA,EAAA,qCAAA;EHmXF;AACF;AG/WA;EACE;IACE,YAAA,EAAA,iDAAA;IACA,aAAA,EAAA,yCAAA;IACA,iBAAA,EAAA,2BAAA;EHiXF;EG/WA;IACE,mBAAA;EHiXF;EG/WA;IACE,YAAA;IACA,aAAA,EAAA,0BAAA;IACA,iBAAA,EAAA,qCAAA;EHiXF;AACF;AG7WA;EACE;IACE,WAAA,EAAA,qCAAA;IACA,YAAA,EAAA,iDAAA;IACA,aAAA,EAAA,yCAAA;IACA,eAAA,EAAA,mBAAA;EH+WF;EG7WA;IACE,mBAAA;EH+WF;EG7WA;IACE,YAAA;IACA,aAAA,EAAA,0BAAA;IACA,iBAAA,EAAA,qCAAA;EH+WF;EG7WA;IACE,UAAA;EH+WF;AACF;AI3kBA;EACI,YAAA;EACA,WAAA;EACA,aAAA;AJ6kBJ;;AI1kBA;EACI,aAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;AJ6kBJ;;AI1kBA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;EACA,uDAAA;AJ6kBJ;;AItkBA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AJykBJ;;AItkBA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AJykBJ;;AItkBA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AJykBJ;;AItkBA,+BAAA;AACA;EACI,yBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA,EAAA,qBAAA;AJykBJ;;AItkBA;EACI,YAAA;EACA,WAAA;AJykBJ;;AItkBA;EACI,yBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AJykBJ;;AItkBA;EACI,YAAA;EACA,eAAA;EACA,iBAAA;AJykBJ;;AItkBA,4BAAA;AACA;EAEI,aAAA,EAAA,iCAAA;EACA,yBAAA,EAAA,+BAAA;AJwkBJ;;AIrkBA;EACI,kBAAA,EAAA,uCAAA;EACA,yBAAA,EAAA,4BAAA;EACA,YAAA,EAAA,sBAAA;EACA,YAAA,EAAA,0BAAA;EACA,kBAAA,EAAA,oBAAA;EACA,eAAA,EAAA,4BAAA;EACA,eAAA,EAAA,cAAA;AJwkBJ;;AIrkBA;EACI,kBAAA,EAAA,uCAAA;EACA,qBAAA,EAAA,4BAAA;EACA,YAAA,EAAA,sBAAA;EACA,YAAA,EAAA,0BAAA;EACA,kBAAA,EAAA,oBAAA;EACA,eAAA,EAAA,4BAAA;EACA,eAAA,EAAA,cAAA;AJwkBJ;;AIjkBA;EACI,aAAA,EAAA,iCAAA;EACA,yBAAA,EAAA,+BAAA;EACA,SAAA,EAAA,0BAAA;AJokBJ;;AIjkBA;EACI,kBAAA,EAAA,uCAAA;EACA,qBAAA,EAAA,+BAAA;EACA,YAAA,EAAA,qBAAA;EACA,YAAA,EAAA,0BAAA;EACA,kBAAA,EAAA,oBAAA;EACA,eAAA,EAAA,4BAAA;EACA,eAAA,EAAA,cAAA;AJokBJ;;AIjkBA;EACI,kBAAA,EAAA,uCAAA;EACA,yBAAA,EAAA,4BAAA;EACA,YAAA,EAAA,sBAAA;EACA,YAAA,EAAA,0BAAA;EACA,kBAAA,EAAA,oBAAA;EACA,eAAA,EAAA,4BAAA;EACA,eAAA,EAAA,cAAA;AJokBJ;;AIjkBA;EACI,iBAAA,EAAA,sCAAA;EACA,YAAA,EAAA,4CAAA;EACA,sBAAA,EAAA,yBAAA;EACA,kBAAA,EAAA,oBAAA;EACA,YAAA,EAAA,eAAA;EACA,uBAAA,EAAA,qBAAA;AJokBJ;;AIjkBA;EACI,YAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,uCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;AJokBJ;;AI/jBA;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;AJkkBJ;;AI/jBA;EACI,qBAAA,EAAA,2BAAA;EACA,UAAA,EAAA,2BAAA;EACA,SAAA,EAAA,0BAAA;AJkkBJ;;AI/jBE;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA,EAAA,sBAAA;EACA,mBAAA,EAAA,6BAAA;AJkkBJ;;AI/jBE;EACE,WAAA,EAAA,wCAAA;EACA,kBAAA,EAAA,2BAAA;EACA,OAAA,EAAA,yBAAA;EACA,MAAA,EAAA,uBAAA;EACA,YAAA,EAAA,iCAAA;EACA,UAAA,EAAA,qBAAA;EACA,uBAAA,EAAA,qBAAA;AJkkBJ;;AI/jBE;EACE,WAAA,EAAA,wCAAA;EACA,kBAAA,EAAA,2BAAA;EACA,UAAA,EAAA,oCAAA;EACA,MAAA,EAAA,yCAAA;EACA,UAAA,EAAA,qBAAA;EACA,WAAA,EAAA,sBAAA;EACA,uBAAA,EAAA,qBAAA;EACA,kBAAA,EAAA,qBAAA;AJkkBJ;;AI/jBE;EACE,eAAA,EAAA,0BAAA;EACA,cAAA,EAAA,wCAAA;AJkkBJ;;AI3jBE,qDAAA;AAKA,yEAAA;AAKA,4CAAA;AACA;EACE;IACE,aAAA;EJsjBJ;EIpjBE;IACI,kBAAA;IACA,WAAA,EAAA,mCAAA;IACA,gBAAA,EAAA,6DAAA;IACA,YAAA,EAAA,gEAAA;EJsjBN;EIhjBE;IACI,cAAA;EJkjBN;AACF;AI/iBE;EACE,aAAA,EAAA,2BAAA;EACA,8BAAA,EAAA,uCAAA;EACA,mBAAA,EAAA,mCAAA;EACA,WAAA,EAAA,2DAAA;AJijBJ;;AI9iBE;EACE,aAAA,EAAA,2BAAA;EACA,SAAA,EAAA,wBAAA;AJijBJ;;AI9iBE;EACE,WAAA,EAAA,cAAA;EACA,YAAA;EACA,kBAAA,EAAA,kCAAA;EACA,iBAAA,EAAA,8BAAA;EACA,eAAA,EAAA,qCAAA;EACA,0BAAA,EAAA,iBAAA;AJijBJ;;AI9iBE;EACE,qBAAA,EAAA,8BAAA;AJijBJ;;AI7iBE;EACE,aAAA,EAAA,2BAAA;EACA,8BAAA,EAAA,oCAAA;EACA,mBAAA,EAAA,mCAAA;EACA,WAAA,EAAA,2DAAA;EACA,cAAA;AJgjBJ;;AI7iBE;EACE,aAAA,EAAA,6BAAA;EACA,SAAA,EAAA,0BAAA;AJgjBJ;;AI7iBE;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA,EAAA,mCAAA;EACA,sCAAA;AJgjBJ;;AI7iBE;EACE,yBAAA,EAAA,2BAAA;AJgjBJ;;AI7iBE;EACE,YAAA;AJgjBJ;;AKx1BA;EACE,yBAPsB;EAQtB,aAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAXiB;EAYjB,gBAAA;AL21BF;;AKx1BA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;AL21BF;;AKx1BA;EACE,eAAA;EACA,iBAAA;AL21BF;;AKx1BA;EACE,eAAA;EACA,iBAAA;AL21BF;;AKx1BA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AL21BF;;AKx1BA;EACE,yBAzCwB;EA0CxB,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;AL21BF;AKz1BE;EACE,uCAAA;AL21BJ;AKx1BE;EACE,oCAAA;AL01BJ;AKv1BE;EACE,qCAAA;ALy1BJ;;AKr1BA;EACE,iBAAA;EACA,mBAAA;ALw1BF;;AKr1BA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8CAAA;ALw1BF;;AKr1BA;EACE,yBAhFwB;EAiFxB,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;ALw1BF;;AKr1BA;EACE,yBA1FwB;EA2FxB,YAAA;EACA,YA1FkB;EA2FlB,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ALw1BF;AKt1BE;EACE,mCAAA;ALw1BJ;;AKp1BA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBA7GwB;EA8GxB,YA5GkB;EA6GlB,kBAAA;EACA,YAAA;EACA,eAAA;EACA,wCAAA;EACA,kDAAA;ALu1BF;AKr1BE;EACE,mCAAA;ALu1BJ;;AKn1BA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;ALs1BF;;AKn1BA;EACE;IACE,2BAAA;IACA,UAAA;ELs1BF;EKp1BA;IACE,wBAAA;IACA,UAAA;ELs1BF;AACF;AKn1BA;EACE;IACE,4BAAA;IACA,UAAA;ELq1BF;EKn1BA;IACE,wBAAA;IACA,UAAA;ELq1BF;AACF;AKj1BA;EACE;IACE,iBAAA;IACA,iBAAA;ELm1BF;EKh1BA;IACE,iBAAA;IACA,gBAAA;ELk1BF;EK/0BA;IACE,iBAAA;IACA,iBAAA;ELi1BF;EK90BA;IACE,gBAAA;IACA,YAAA;ELg1BF;EK70BA;IACE,iBAAA;IACA,iBAAA;EL+0BF;AACF;AK50BA;EACE;IACE,eAAA;IACA,cAAA;EL80BF;EK30BA;IACE,iBAAA;IACA,gBAAA;EL60BF;EK10BA;IACE,iBAAA;IACA,iBAAA;EL40BF;EKz0BA;IACE,iBAAA;IACA,iBAAA;EL20BF;AACF;AMphCA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA,EAAA,kBAAA;EACA,gBAAA,EAAA,iDAAA;EACA,cAAA,EAAA,iCAAA;ANshCF;;AMnhCE;EACE,eAAA;EACA,YAAA;ANshCJ;;AMnhCE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;ANshCJ;AMphCI;EACE,cAAA,EAAA,sBAAA;ANshCN;;AMlhCE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;ANqhCJ;AMnhCI;EACE,cAAA,EAAA,sBAAA;ANqhCN;;AMjhCE;EACE,YAAA;EACA,UAAA;EACA,eAAA;ANohCJ;;AMjhCE;EACE,WAAA;ANohCJ;;AMjhCA,gBAAA;AACA;EACE,YAAA,EAAA,sBAAA;EACA,YAAA,EAAA,2BAAA;EACA,mBAAA,EAAA,uBAAA;EACA,kBAAA,EAAA,iCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,yBAAA,EAAA,uCAAA;EACA,YAAA,EAAA,qBAAA;EACA,eAAA,EAAA,oBAAA;EACA,eAAA,EAAA,+BAAA;EACA,YAAA,EAAA,mBAAA;EACA,aAAA,EAAA,mBAAA;ANmhCF;AMjhCE;EACE,yBAAA,EAAA,oCAAA;ANmhCJ;;AM/gCA;EACE;IACE,aAAA,EAAA,sCAAA;ENkhCF;EMhhCA;IAEE,eAAA,EAAA,gCAAA;IACA,kBAAA,EAAA,8CAAA;ENihCF;AACF;AM9gCA,oCAAA;AACA;EACE;IACE,UAAA;ENghCF;EM9gCF;IACE,YAAA,EAAA,+CAAA;IACA,eAAA,EAAA,6BAAA;IACA,kBAAA;ENghCA;AACF;AM7gCA;EACE;IACE,aAAA,EAAA,sCAAA;IACA,UAAA;EN+gCF;EM7gCA;IAEE,eAAA,EAAA,qBAAA;IACA,kBAAA;EN8gCF;AACF;AM3gCA;EACE;IACE,aAAA;IACA,UAAA;EN6gCF;EM3gCA;IACE,WAAA,EAAA,kDAAA;IACA,eAAA,EAAA,6DAAA;IACA,kBAAA,EAAA,oDAAA;IACA,YAAA;EN6gCF;AACF;AM1gCA,kBAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA,EAAA,iCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA,EAAA,+BAAA;AN4gCF;;AMzgCA,kBAAA;AACA;EACE,yBAAA,EAAA,oBAAA;EACA,kBAAA,EAAA,yCAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA,EAAA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA,EAAA,mCAAA;EACA,uBAAA,EAAA,kCAAA;EACA,mBAAA,EAAA,oCAAA;EACA,iBAAA,EAAA,kCAAA;EACA,gBAAA,EAAA,8CAAA;AN4gCF;;AMzgCA,sBAAA;AACA;EACE,eAAA,EAAA,yBAAA;EACA,mBAAA,EAAA,gCAAA;AN4gCF;;AMzgCA,uBAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA,EAAA,2BAAA;AN4gCF;;AMzgCA;EACE,yBAAA,EAAA,oBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AN4gCF;;AMzgCA;EACE,yBAAA,EAAA,yBAAA;AN4gCF;;AMzgCA,iBAAA;AACA;EACE,yBAAA,EAAA,4BAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;AN4gCF;;AMzgCA;EACE,yBAAA,EAAA,yBAAA;AN4gCF;;AMngCA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;ANsgCF;;AMngCA;EACE,gBAAA;EACA,UAAA;EACA,qBAAA;ANsgCF;;AMngCA;EACE,eAAA;EACA,aAAA;ANsgCF;;AMngCA;EACE,YAAA;ANsgCF;;AMngCA;EACE,UAAA;ANsgCF;;AMngCA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ANsgCF;;AMngCA;EACE,sBAAA;EACA,mBAAA;ANsgCF;;AMngCA;EACE,UAAA;EACA,mBAAA;ANsgCF;;AMngCA;EAGE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA,EAAA,yBAAA;ANogCF;;AMhgCA;EACE;IACE,gBAAA,EAAA,gDAAA;IACA,gBAAA,EAAA,8BAAA;IACA,aAAA,EAAA,uCAAA;IACA,UAAA,EAAA,gCAAA;ENmgCF;EMhgCA;IACE,gBAAA,EAAA,4CAAA;IACA,mBAAA,EAAA,oCAAA;ENkgCF;EM//BA;IACE,eAAA,EAAA,qCAAA;IACA,iBAAA,EAAA,oBAAA;IACA,WAAA,EAAA,eAAA;ENigCF;AACF;AM9/BA;EACE,iBAAA,EAAA,0CAAA;EACA,gBAAA,EAAA,8BAAA;EACA,WAAA;ANggCF;;AOryCA;EACI,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA,EAAA,+DAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA,EAAA,4CAAA;EACA,YAAA;APwyCJ;;AOryCA,uCAAA;AACA;EACI;IACI,gBAAA,EAAA,sDAAA;IACA,eAAA,EAAA,gCAAA;IACA,kBAAA,EAAA,gDAAA;EPwyCN;AACF;AOryCA,qDAAA;AACA;EACI;IACI,gBAAA,EAAA,yDAAA;IACA,eAAA,EAAA,uCAAA;EPuyCN;AACF;AOpyCA,yEAAA;AACA;EACI;IAEI,eAAA,EAAA,qBAAA;EPqyCN;AACF;AOlyCA,4CAAA;AACA;EACI;IACI,eAAA,EAAA,kDAAA;IACA,eAAA,EAAA,mDAAA;IACA,YAAA,EAAA,gDAAA;IACA,kBAAA,EAAA,iDAAA;EPoyCN;AACF;AQt1CA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;ARw1CJ;AQt1CI;EACI,cAAA;EACA,sBAAA;ARw1CR;;AQp1CA;EACI,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oDAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;ARu1CJ;;AS92CA,8CAAA;AACA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kCAAA;EACA,mBAAA;ATi3CJ;;AS92CA,8BAAA;AACA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;ATi3CJ;;AS92CA;EACI,qBAAA;EACA,0CAAA;ATi3CJ;;AS92CA,yBAAA;AACA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;ATi3CJ;;AS92CA;EACI,yBAAA;ATi3CJ;;AS92CA;EACI;IACI,WAAA;IACA,YAAA;ETi3CN;AACF;AU95CA,sBAAA;AACA;EACE,aAAA;EACA,sBAAA,EAAA,2BAAA;EACA,8BAAA,EAAA,0BAAA;EACA,YAAA,EAAA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AVg6CF;;AU75CA,iBAAA;AACA;EACE,kBAAA;AVg6CF;AU95CE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AVg6CJ;;AU55CA;EACE,6BAAA;AV+5CF;;AU75CA;EACE,6BAAA,EAAA,qDAAA;EACA,eAAA,EAAA,oDAAA;AVg6CF;;AU75CA,qBAAA;AACA;EACE,gBAAA;EACA,UAAA;EACA,WAAA;AVg6CF;AU95CE;EACE,WAAA;EACA,mBAAA;AVg6CJ;AU95CI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA,EAAA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AVg6CN;AU95CM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yHAAA,EAAA,iCAAA;AVg6CR;AU75CM;EACE,sBAAA;AV+5CR;AU55CM;EACE,sBAAA,EAAA,8BAAA;AV85CR;;AUv5CA,YAAA;AAIA;EACE,YAAA;EACA,0CAAA;EACA,mCAAA;EACA,mBAAA;EACA,8BAAA;AVu5CF;;AUp5CA,2BAAA;AACA;EACE;IACE,aAAA,EAAA,6BAAA;EVu5CF;EUp5CA;IACE,aAAA,EAAA,uCAAA;EVs5CF;AACF;AU94CA,qDAAA;AACA;EAII;IACE,WAAA;EV64CJ;EUz4CA;IACE,YAAA;EV24CF;AACF;AUt4CA;EACE,aAAA,EAAA,sBAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,6BAAA;EACA,cAAA,EAAA,kCAAA;EACA,aAAA;EACA,gBAAA,EAAA,yCAAA;AVw4CF;;AUr4CA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA,EAAA,mCAAA;EACA,aAAA;EACA,mBAAA,EAAA,uBAAA;EACA,YAAA,EAAA,sCAAA;EACA,YAAA,EAAA,uCAAA;AVw4CF;;AUr4CA;EACE,WAAA,EAAA,kBAAA;EACA,YAAA;EACA,yHAAA;AVw4CF;;AUr4CA;EACE,eAAA,EAAA,iBAAA;EACA,eAAA,EAAA,qCAAA;EACA,WAAA,EAAA,uBAAA;AVw4CF;;AUr4CA,6CAAA;AACA;EACE;IACE,aAAA,EAAA,+BAAA;EVw4CF;EUr4CA;IACE,aAAA,EAAA,uCAAA;EVu4CF;AACF;AUn4CA;EACE;IACE,aAAA;EVq4CF;AACF;AUl4CA,0DAAA;AAqCA;EACE,gBAAA,EAAA,oCAAA;EACA,aAAA;EACA,yBAAA,EAAA,cAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;EACE,mBAAA;EACA,2BAAA;AVg2CJ;;AU71CA;EACE,yBAAA,EAAA,wBAAA;AVg2CF;;AUv1CA;EACE,WAAA,EAAA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AV01CF;;AW9kDA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,uCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AXilDF;;AWxkDA,qDAAA;AAKA,yEAAA;AAKA,4CAAA;AACA;EACE;IACE,aAAA;EXmkDF;AACF;AWhkDA;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;AXkkDF;;AW9jDA;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;AXikDF;;AW9jDA;EACE,qBAAA;EACA,UAAA;EACA,qBAAA,EAAA,YAAA;EACA,wBAAA,EAAA,0BAAA;EACA,gBAAA;AXikDF;;AW9jDA;EACE,yBAAA,EAAA,oBAAA;EACA,mBAAA,EAAA,oBAAA;EACA,aAAA,EAAA,oBAAA;EACA,aAAA;EACA,8BAAA,EAAA,kDAAA;EACA,mBAAA,EAAA,sCAAA;EACA,YAAA,EAAA,6DAAA;EACA,mBAAA,EAAA,wCAAA;AXikDF;;AW9jDA;EACE,aAAA;EACA,sBAAA,EAAA,kDAAA;AXikDF;;AW9jDA;EACE,eAAA;EACA,iBAAA;AXikDF;;AW9jDA;EACE,eAAA;EACA,cAAA;EACA,eAAA,EAAA,mCAAA;EACA,iBAAA;AXikDF;;AW9jDA;EACE,aAAA;EACA,uBAAA,EAAA,wDAAA;EACA,mBAAA,EAAA,sDAAA;AXikDF;;AW7jDA;EACE,gBAAA;AXgkDF;;AW7jDA;EACE,aAAA;EACA,SAAA;AXgkDF;;AW7jDA;EACE,kBAAA,EAAA,qCAAA;EACA,sBAAA,EAAA,wCAAA;AXgkDF;;AW7jDA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AXgkDF;;AW7jDA;EACE,WAAA,EAAA,sBAAA;EACA,YAAA;EACA,yHAAA;AXgkDF;;AW7jDA;EACE,gDAAA,EAAA,4CAAA;AXgkDF;;AY7rDA;EAEE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AZ+rDF;;AYzrDA;EACE,eAAA;EACA,YAAA;AZ4rDF;;AYzrDA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AZ4rDF;;AYzrDA;EACE,WAAA,EAAA,sDAAA;EACA,YAAA;EACA,yBAAA,EAAA,gCAAA;EACA,oBAAA;EACA,gBAAA,EAAA,mDAAA;AZ4rDF;;AYzrDA;EACE,YAAA;EACA,wBAAA;EACA,oBAAA;EACA,SAAA,EAAA,0CAAA;EACA,kCAAA,EAAA,uDAAA;AZ4rDF;;AYzrDA;EACE,aAAA;EACA,8BAAA,EAAA,6EAAA;AZ4rDF;;AYzrDA;EACE,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA,EAAA,oBAAA;EACA,UAAA,EAAA,kCAAA;EACA,sBAAA,EAAA,wEAAA;AZ4rDF;;AYzrDA;EACE,gBAAA;EACA,cAAA,EAAA,oCAAA;EACA,qBAAA,EAAA,sCAAA;AZ4rDF;;AYzrDA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AZ4rDF;;AYxrDA;EACE,UAAA,EAAA,kBAAA;EACA,gBAAA,EAAA,yBAAA;EACA,gBAAA,EAAA,mCAAA;EAEA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA,EAAA,wBAAA;EAEA,gBAAA,EAAA,+CAAA;AZwrDF;;AYrrDA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AZwrDF;;AYrrDA;EACE,mBAAA;AZwrDF;;AYrrDA;EACE,mBAAA;AZwrDF;;AYjrDA;EACE;IACE,YAAA;EZorDF;EYlrDA;IACE,UAAA,EAAA,uBAAA;IACA,gBAAA;IACA,aAAA,EAAA,mBAAA;EZorDF;AACF;AYjrDA;EACE;IACE,YAAA;EZmrDF;EYjrDA;IACE,UAAA,EAAA,sBAAA;IACA,gBAAA;IACA,aAAA;EZmrDF;EYjrDA;IACE,eAAA,EAAA,uBAAA;EZmrDF;EYhrDA;IACE,eAAA,EAAA,0BAAA;EZkrDF;EY/qDA;IACE,QAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;EZirDF;AACF;Aav0DA;EACI,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yCAAA;EACA,SAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;Aby0DJ;;Aat0DA;EACI,6BAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;Aby0DJ;;Aat0DA;EACI,6BAAA;EACA,cAAA;Aby0DJ;;Aat0DA;EACI,YAAA;EACA,eAAA;EACA,iBAAA;Aby0DJ;;Aat0DA;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;Aby0DJ;;Aat0DA;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;Aby0DJ;;Aat0DA;EACI;IACA,kBAAA;IACA,mBAAA;IACA,iBAAA;IACA,oBAAA;Eby0DF;AACF;Acl4DA;EACI,YAAA;EACA,WAAA;EACA,aAAA;Ado4DJ;;Acl4DA;EACI,YAAA,EAAA,kDAAA;EACA,gBAAA,EAAA,8BAAA;EACA,+BAAA,EAAA,oDAAA;Adq4DJ;;Acl4DA;EACI,YAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;Adq4DJ;;Acl4DA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;Adq4DJ;;Acl4DA;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;Adq4DJ;;Acl4DA;EACI,yBAAA;Adq4DJ;;Acl4DA,4BAAA;AAEA,8BAAA;AACA;EACI,aAAA;EACA,2DAAA,EAAA,gCAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA,EAAA,kCAAA;Ado4DJ;;Acj4DA,mBAAA;AACA;EACI,WAAA,EAAA,mCAAA;EACA,gBAAA,EAAA,qCAAA;EACA,yBAAA,EAAA,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,wCAAA;Ado4DJ;;Ach3DA;EACI,WAAA;EACA,aAAA,EAAA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA,EAAA,yEAAA;Adm3DJ;;Ach3DA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA,EAAA,2EAAA;Adm3DJ;;Ac/2DA,yCAAA;AACA;EACI,aAAA;EACA,WAAA;EACA,YAAA,EAAA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA,EAAA,6BAAA;Adk3DJ;;Ac/2DA,gCAAA;AACA;EACI,SAAA,EAAA,0BAAA;EACA,iBAAA;Adk3DJ;;Ac/2DA;EACI,eAAA,EAAA,2BAAA;EACA,gBAAA;EACA,cAAA;Adk3DJ;;Ac/2DA,sBAAA;AACA;EACI,oCAAA;EACA;IACI,0BAAA,EAAA,mBAAA;Edk3DN;Ec/2DE;IACI,cAAA,EAAA,oBAAA;IACA,UAAA,EAAA,iBAAA;IACA,eAAA,EAAA,+CAAA;Edi3DN;Ec92DE;IACI,gBAAA,EAAA,yCAAA;Edg3DN;Ec72DE;IACI,iBAAA,EAAA,yCAAA;Ed+2DN;AACF;Ac52DA;EACI,sBAAA;EACA;IACI,2DAAA,EAAA,mCAAA;Ed82DN;AACF;Ac32DA;EACI,uBAAA;EACA;IACI,2DAAA,EAAA,mCAAA;Ed62DN;AACF;Acz2DA;EACI,yBAAA,EAAA,cAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;Ad22DJ;;Acx2DE;EACE,yBAAA,EAAA,yCAAA;EACA,YAAA;Ad22DJ;;AethEA;EACI,YAAA;EACA,WAAA;EACA,aAAA;AfyhEJ;;AethEE;EACE,YAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AfyhEJ;;AethEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AfyhEJ;;AethEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AfyhEJ;;AethEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AfyhEJ;;AethEE,+BAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AfyhEJ;;AethEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AfyhEJ;;AethEE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AfyhEJ;;AethEE;EACE,eAAA;EACA,iBAAA;AfyhEJ;;AethEE;EACE,eAAA;EACA,cAAA;AfyhEJ;;AethEE,kBAAA;AAMA;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AfohEJ;;AejhEE;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AfohEJ;;AejhEE;EACE,yBAAA;AfohEJ;;AelhEE;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA,EAAA,uCAAA;AfqhEJ;;AelhEE;EACE,yBAAA;AfqhEJ;;AelhEE;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA,EAAA,uCAAA;AfqhEJ;;AgBzoEA;EACI,yBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA,EAAA,uEAAA;AhB4oEJ;;AgBzoEE;EACE,kBAAA;EACA,SAAA,EAAA,0BAAA;EACA,WAAA,EAAA,4BAAA;EACA,aAAA;EACA,SAAA;AhB4oEJ;;AgBzoEE;EACE,yBAAA;AhB4oEJ;;AgBzoEE;EACE,yBAAA;AhB4oEJ;;AgBxoEE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;AhB2oEJ;;AgBvoEE;EACE,WAAA;EACA,YAAA;AhB0oEJ;;AgBvoEE;EACE,YAAA;EACA,mBAAA;AhB0oEJ;;AgBvoEE;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA,EAAA,sCAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AhB0oEJ;;AgBvoEE;EACE,eAAA;EACA,YAAA;AhB0oEJ;;AgBvoEE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AhB0oEJ;;AgBvoEE,kBAAA;AACA;EACE;IACE,aAAA;IACA,UAAA;EhB0oEJ;EgBvoEE;IACE,YAAA;EhByoEJ;EgBtoEE;IACE,eAAA;EhBwoEJ;EgBroEE;IACE,eAAA;EhBuoEJ;AACF;AgBpoEE;EACE;IACE,YAAA;EhBsoEJ;EgBnoEE;IACE,eAAA;EhBqoEJ;EgBloEE;IACE,eAAA;EhBooEJ;AACF;AiB1uEA;;;EAGE,sBAAA,EAAA,0DAAA;AjB4uEF;;AiBzuEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA,EAAA,uCAAA;EACA,aAAA;AjB4uEF;;AiBzuEA;EACE,aAAA;EACA,8BAAA,EAAA,4BAAA;EACA,qBAAA;AjB4uEF;;AiBzuEA;EACE,aAAA;AjB4uEF;;AiBzuEA;EACE,YAAA;AjB4uEF;;AiBzuEA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AjB4uEF;;AiBzuEA;EACE,WAAA;EACA,YAAA;AjB4uEF;;AiBzuEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AjB4uEF;;AiBzuEA;EACE,WAAA;EACA,YAAA;EACA,+BAAA;AjB4uEF;;AiBzuEA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;AjB4uEJ;;AiBzuEA;EACE,WAAA,EAAA,wCAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AjB4uEF;;AiBzuEA;EACE,WAAA;AjB4uEF;;AiBzuEA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AjB4uEF;;AiBzuEA;EACE,WAAA;EACA,YAAA;AjB4uEF;;AiBzuEA;EACI,gBAAA,EAAA,sBAAA;EACA,YAAA,EAAA,kBAAA;EACA,eAAA,EAAA,sBAAA;EACA,UAAA,EAAA,mBAAA;AjB4uEJ;;AiBzuEE;EACE,WAAA,EAAA,0BAAA;EACA,YAAA;AjB4uEJ;;AiBtuEE;EACE,aAAA;EACA,mBAAA;EACA,WAAA,EAAA,0CAAA;EACA,SAAA;AjByuEJ;;AiBtuEE;EACE,SAAA,EAAA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AjByuEJ;;AiBtuEE;EACE,aAAA;EACA,mBAAA;AjByuEJ;;AiBtuEE;EACE,WAAA,EAAA,mBAAA;EACA,YAAA,EAAA,oBAAA;EACA,qBAAA,EAAA,0BAAA;EACA,kBAAA,EAAA,qCAAA;AjByuEJ;;AiBvuEE;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA,EAAA,8CAAA;AjB0uEJ;;AiBvuEE;EACE,qBAAA,EAAA,uCAAA;AjB0uEJ;;AiBvuEE;EACE,WAAA;EACA,YAAA;EACA,+BAAA;AjB0uEJ","sourcesContent":["@import url(https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap);\n\nhtml,\nbody {\n    background-color: #222222;\n    overflow: hidden;\n    font-family: 'Nunito', sans-serif;\n    margin: 0px;\n    padding: 0px;\n    height: 100%; // Ensures the body takes the full height of the viewport\n}\n\n.layout {\n  display: flex;\n  height: 100vh; /* Pour que la mise en page prenne toute la hauteur de la fenêtre */\n}\n\n.content {\n  height: 100vh;\n  flex-grow: 1;\n  padding: 0px;\n  color: red;\n}\n\n@import './pages/login.scss';\n@import './pages/Home.scss';\n@import './pages/documentsDetail.scss';\n@import './pages/profile.scss';\n@import './pages/subscription.scss';\n\n@import './components/loginBox.scss';\n@import './components/input.scss';\n@import './components/confirmMail.scss';\n@import './components/ConfirmationBox.scss';\n@import './components/Sidebar.scss';\n@import './components/DocumentSideBar.scss';\n@import './components/stockageContainer.scss';\n@import './components/Offer.scss';\n@import './components/Scenarios.scss';\n@import './components/ScenarioDetail.scss';\n@import './components/disclaimer.scss';\n@import './components/NewScenarios.scss';\n@import './components/DetailStockage.scss';\n",".login-container {\r\n    background-color: #222222;\r\n    height: 100vh;\r\n    width: 100vw;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* pour occuper toute la hauteur de l'écran */\r\n}\r\n\r\n.login-image {\r\n    width: 200px;\r\n    margin-bottom: 20px;\r\n  }",".home-page {\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    \r\n    /* Ajout de la propriété flexbox */\r\n}\r\n\r\n.main-box-document {\r\n    display: flex;\r\n    height: 100%;\r\n    gap: 44px;\r\n    width: 100%;\r\n    padding-left: 42px;\r\n    padding-right: 42px;\r\n    padding-top: 32px;\r\n    flex-direction: column;\r\n    color: white;\r\n  }\r\n\r\n\r\n\r\n.top-page {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.page-title {\r\n    font-size: 24px;\r\n    color: white;\r\n}\r\n\r\n.add-button {\r\n    background-color: #007BFF;\r\n    color: white;\r\n    padding: 15px 20px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    margin-left: 10px;\r\n}\r\n\r\n.add-button:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n\r\n.search-bar-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: #2A2A2A;\r\n    border-radius: 100px;\r\n    padding: 10px;\r\n}\r\n\r\n.search-bar {\r\n    flex-grow: 1;\r\n    /* Prend toute la largeur restante */\r\n    padding: 10px;\r\n    border-radius: 100px;\r\n    border: none;\r\n    font-size: 17px;\r\n    color: #FFFFFF;\r\n    background-color: #2A2A2A;\r\n    outline: none;\r\n    /* Retire le contour bleu par défaut */\r\n}\r\n\r\n.search-icon {\r\n    color: #FFFFFF;\r\n}\r\n\r\n.document-box {\r\n    background-color: #333333;\r\n    border-radius: 10px;\r\n    padding: 15px;\r\n    gap: 20px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    color: white;\r\n    margin-bottom: 15px;\r\n    width: 100%; /* Ensure full width by default */\r\n    box-sizing: border-box; /* Prevent overflow */\r\n}\r\n\r\n.Document-text-container {\r\n    display: flex;\r\n    gap: 8px;\r\n}\r\n\r\n.end-part-document {\r\n    gap: 60px;\r\n    display: flex;\r\n}\r\n\r\n.Document-Icon-container {\r\n    display: flex;\r\n    gap: 8px;\r\n}\r\n\r\n.modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    /* Fond semi-transparent pour l'overlay */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n\r\n\r\n.close-button {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.close-button:hover {\r\n    background: none;\r\n}\r\n\r\n.modal-title {\r\n    font-weight: 700;\r\n    font-size: 25px;\r\n    line-height: 34.1px;\r\n    color: white;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n}\r\n.home-documentList{\r\n    list-style-type: none;\r\n    padding: 0;\r\n    scrollbar-width: none; /* Firefox */\r\n    -ms-overflow-style: none; /* Internet Explorer 10+ */\r\n    overflow-y: auto;\r\n}\r\n\r\n.document-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n    max-height: 500px;\r\n    padding: 10px;\r\n    overflow-y: auto; /* Enable scrolling when content overflows */\r\n    scrollbar-width: none; /* Firefox */\r\n    -ms-overflow-style: none; /* IE and Edge */\r\n  }\r\n  .document-container::-webkit-scrollbar {\r\n    display: none; /* Hide scrollbar in WebKit browsers */\r\n  }\r\n.document-preview {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    background-color: #444;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n}\r\n\r\n.document-icon {\r\n    width: 50px;\r\n    height: 50px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.document-container {\r\n    display: flex;\r\n    flex-wrap: wrap; /* Permet de revenir à la ligne si l'espace est insuffisant */\r\n    gap: 10px;\r\n    max-height: 500px; /* Limite la hauteur du conteneur pour forcer le défilement */\r\n    overflow-y: auto; /* Rendre le conteneur scrollable verticalement */\r\n    padding: 10px;\r\n  \r\n    /* Masquer la barre de scroll */\r\n    scrollbar-width: none; /* Firefox */\r\n    -ms-overflow-style: none; /* IE et Edge */\r\n  }\r\n  \r\n  .document-container::-webkit-scrollbar {\r\n    display: none; /* Chrome, Safari et Opera */\r\n  }\r\n  \r\n  .document-preview {\r\n    width: 150px;\r\n    height: 150px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    overflow: hidden;\r\n    background: none; /* Couleur de fond pour les documents */\r\n  }\r\n  \r\n  .upload-button {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    background-color: #444;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    width: 150px;\r\n    height: 150px;\r\n  }\r\n  \r\n  .upload-icon {\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n  \r\n  .document-content {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n  }\r\n\r\n \r\n.modal-content {\r\n  width: 90%; /* Adjusts to 90% of the screen width */\r\n  max-width: 1078px; /* Ensures it doesn't go beyond 1078px */\r\n  height: 725px;\r\n  max-height: 90vh; /* Maximum height at 90% of the viewport */\r\n  background-color: #333333;\r\n  border-radius: 15px;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 20px;\r\n  overflow-y: auto; /* Allows scrolling if content overflows */\r\n}\r\n\r\n.upload-submit-button {\r\n  position: absolute;\r\n  bottom: 20px; \r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background-color: #4caf50;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n}\r\n\r\n.upload-submit-button:hover {\r\n  background-color: #45a049;\r\n}\r\n\r\n\r\n  .box-container {\r\n    background-color: #2a2a2a; /* Dark background for contrast */\r\n    padding: 20px; /* Padding inside the box */\r\n    border-radius: 10px; /* Rounded corners */\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center; /* Center content horizontally */\r\n    margin-bottom: 20px; /* Space below the box */\r\n    color: white; /* Text color */\r\n    max-width: 80%; /* Restrict width */\r\n    width: 100%;\r\n    margin: auto; /* Center horizontally */\r\n  }\r\n  \r\n  /* Optional title styling */\r\n  .box-container h3 {\r\n    margin-bottom: 15px;\r\n    font-size: 22px;\r\n    font-weight: bold;\r\n    text-align: center;\r\n  }\r\n\r\n  @media (max-width: 1024px) {\r\n    .main-box-document {\r\n        max-width: 400px;\r\n\r\n    }\r\n    .document-box {\r\n        flex-direction: column; /* Stack elements vertically on smaller screens */\r\n        padding: 10px; /* Reduce padding for small screens */\r\n        gap: 15px; /* Reduce space between elements */\r\n    }\r\n    .Document-text-container {\r\n        justify-content: center; /* Center content when stacked */\r\n    }\r\n    .end-part-document {\r\n        flex-direction: column; /* Stack the right-side elements vertically */\r\n        gap: 10px; /* Adjust gap for smaller screens */\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .modal-content {\r\n      width: 90%; /* Smaller width for tablets and below */\r\n      padding: 15px;\r\n    }\r\n  \r\n    .upload-submit-button {\r\n      padding: 8px 16px; /* Smaller padding for smaller screens */\r\n      font-size: 14px; /* Smaller font size */\r\n      margin-bottom: 20px;\r\n    }\r\n    .document-box {\r\n        padding: 10px; /* Reduce padding further for very small screens */\r\n        gap: 10px; /* Reduce the gap between elements */\r\n    }\r\n\r\n    .Document-text-container {\r\n        font-size: 14px; /* Reduce font size for smaller screens */\r\n    }\r\n\r\n    .document-Name {\r\n        font-size: 16px; /* Adjust document name size */\r\n        text-align: center; /* Center-align text */\r\n    }\r\n\r\n    .end-part-document {\r\n        gap: 8px; /* Reduce gap between date and icons */\r\n    }\r\n\r\n    .Document-Icon-container {\r\n        justify-content: center; /* Center icons */\r\n    }\r\n  }\r\n\r\n  @media (max-width: 475px) {\r\n    .main-box-document {\r\n        display: flex;\r\n        flex-direction: column;\r\n        height: 100%;\r\n        gap: 10px;\r\n        padding-left: 20px;\r\n        padding-right: 20px;\r\n        padding-top: 10px;\r\n        overflow-y: auto; /* Enable vertical scrolling */\r\n        max-height: 100vh; /* Ensure the height does not exceed the viewport */\r\n    }\r\n    .document-box {\r\n        padding: 20px; /* Further reduce padding for mobile */\r\n        gap: 8px; /* Reduce gap */\r\n        height: auto;\r\n        // min-width: 200px;\r\n    }\r\n\r\n    .document-Name {\r\n        font-size: 14px; /* Smaller font size for very small screens */\r\n        text-align: center; /* Center-align text */\r\n    }\r\n\r\n    .Document-text-container {\r\n        justify-content: center;\r\n    }\r\n\r\n    .end-part-document {\r\n        gap: 5px; /* Tighten gap on smaller screens */\r\n    }\r\n} ",".document-detail {\r\n  // position: relative;\r\n  display: flex;\r\n  height: 100vh;\r\n  width: 100vw;\r\n  // justify-content: center;\r\n  // align-items: center;\r\n  // flex-direction: column;\r\n\r\n}\r\n\r\n.back-button {\r\n  position: fixed;\r\n  top: 20px;\r\n  left: 275px;\r\n  z-index: 100;\r\n  /* Ensure it's above other content */\r\n  cursor: pointer;\r\n}\r\n\r\n.back-button img {\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n.file-display {\r\n  // flex: 1;\r\n  display: flex;\r\n  // justify-content: center;\r\n  align-items: center;\r\n  margin-top: 80px;\r\n  // width: 500px;\r\n  // max-height: 200px;\r\n  \r\n}\r\n\r\n.document-pdf {\r\n  padding-left: 20px;\r\n  width: 500px;\r\n  height: 600px;\r\n  border: none;\r\n  object-fit: cover;\r\n  /* Ensure the document scales well */\r\n}\r\n\r\n\r\n\r\n.document-info {\r\n  font-size: 14px;\r\n  margin: auto 15% auto 2%;\r\n  padding-right: 100px;\r\n  max-width: 500px; /* Maximum width for document info */\r\n  overflow-y: auto; /* Allow vertical scrolling */\r\n  flex-grow: 1; /* Allow this section to grow and take up remaining space */\r\n  padding-bottom: 50px; /* Add some padding to the bottom */\r\n  max-height: 90%;\r\n  // margin-bottom: 20px;\r\n}\r\n\r\n\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  /* Aligns file name and size */\r\n  align-items: center;\r\n  /* Vertically aligns items */\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.header div {\r\n  margin-bottom: 0;\r\n  /* Removes extra space between items */\r\n}\r\n\r\n.document-fields {\r\n  display: flex; /* Change to flex to allow wrapping */\r\n  flex-direction: column; /* Stack items vertically */\r\n  gap: 10px; /* Space between items */\r\n}\r\n\r\n.field-row {\r\n  display: flex;\r\n  flex-wrap: wrap; /* Allow wrapping for long text */\r\n  justify-content: space-between; /* Keep the label and value apart */\r\n}\r\n\r\n.field-label {\r\n  text-transform: lowercase;\r\n  font-size: 16px;\r\n  color: #8f8f8f;\r\n  flex: 0 0 30%; /* Adjusts the label width */\r\n}\r\n\r\n.field-value {\r\n  font-size: 16px;\r\n  color: #ffffff;\r\n  flex: 1; /* Allow the value to take the remaining space */\r\n  min-width: 100px; /* Optional: Set a minimum width to prevent the value from being too small */\r\n}\r\n\r\n\r\n.button-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  /* Positions one button on the left and the other on the right */\r\n  margin-top: 20px;\r\n  width: 100%;\r\n  /* Make sure the buttons span the full width of the parent container */\r\n}\r\n\r\nbutton {\r\n  padding: 10px 20px;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  border: none;\r\n  // flex-basis: 48%; /* Optional: Ensure both buttons have a similar size, adjust percentage as needed */\r\n}\r\n\r\n.delete-button {\r\n  background-color: #ff4d4f;\r\n  color: white;\r\n}\r\n\r\n.change-button {\r\n  background-color: #4caf50;\r\n  color: white;\r\n}\r\n\r\nbutton:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.add-Button-tag {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  align-items: center;\r\n}\r\n\r\n.add-Button-tag-icon {\r\n  width: 24px; /* Taille de l'icône */\r\n  height: 24px;\r\n  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);\r\n}\r\n\r\n.add-Button-tag:hover {\r\n  background: none;\r\n}\r\n\r\n.Trash-Button-tag {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  align-items: center;\r\n}\r\n\r\n.Trash-Button-tag:hover {\r\n  background: none;\r\n}\r\n\r\n.file-display-img {\r\n  width: 500px;\r\n  height: 600px; /* Maintain aspect ratio */\r\n  object-fit: cover; /* Ensure the image scales properly */\r\n}\r\n\r\n\r\n@media (max-width: 1200px) {\r\n  .document-pdf {\r\n    width: 300px; /* Change width to 80% for medium-sized screens */\r\n    height: 400px; /* Allow height to adjust automatically */\r\n    padding-left: 10px; /* Reduce padding on smaller screens */\r\n  }\r\n\r\n  .file-display-img {\r\n    width: 300px;\r\n    height: 400px; /* Maintain aspect ratio */\r\n    object-fit: cover; /* Ensure the image scales properly */\r\n  }\r\n\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .document-pdf {\r\n    width: 300px; /* Change width to 80% for medium-sized screens */\r\n    height: 400px;/* Allow height to adjust automatically */\r\n    padding-left: 5px; /* Further reduce padding */\r\n  }\r\n  .document-info {\r\n    padding-right: 10px;\r\n  }\r\n  .file-display-img {\r\n    width: 300px;\r\n    height: 400px; /* Maintain aspect ratio */\r\n    object-fit: cover; /* Ensure the image scales properly */\r\n  }\r\n\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .document-pdf {\r\n    width: 100%; /* Full width on very small screens */\r\n    width: 100px; /* Change width to 80% for medium-sized screens */\r\n    height: 200px; /* Allow height to adjust automatically */\r\n    padding-left: 0; /* Remove padding */\r\n  }\r\n  .document-info {\r\n    padding-right: 10px;\r\n  }\r\n  .file-display-img {\r\n    width: 300px;\r\n    height: 400px; /* Maintain aspect ratio */\r\n    object-fit: cover; /* Ensure the image scales properly */\r\n  }\r\n  .back-button{\r\n    left: 10px;\r\n  }\r\n\r\n}",".profile-page {\n    height: 100%;\n    width: 100%;\n    display: flex;\n}\n\n.profile-container {\n    display: flex;\n    height: 100%;\n    gap: 20px;\n    width: 100%;\n    padding-left: 42px;\n    padding-right: 42px;\n    padding-top: 32px;\n    flex-direction: column;\n    color: white;\n}\n\n.profile-info-container {\n    background-color: #333333;\n    padding: 30px;\n    border-radius: 10px;\n    display: flex;\n    gap: 20px;\n    color: white;\n    flex-direction: column;\n    /* Added flex-grow to ensure it takes available space */\n    // flex-grow: 1; \n    // width: 100%;\n    // height: 100%;\n    // flex-wrap: wrap;\n}\n\n.profile-info-title {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 10px;\n}\n\n.information-text {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.info-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n}\n\n/* Apply styles to the labels */\n.info-row strong {\n    text-transform: lowercase;\n    font-size: 16px;\n    color: #8f8f8f;\n    min-width: 150px; /* Adjust if needed */\n}\n\n.downArrow {\n    height: 24px;\n    width: 24px;\n}\n\n.downArrowBtn {\n    background-color: #333333;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    color: white;\n}\n\n.myInfo-text {\n    flex-grow: 1;\n    font-size: 20px;\n    line-height: 27px;\n}\n\n/* Modifier button styling */\n.button-container {\n    // margin-top: auto; /* Pushes the button to the bottom */\n    display: flex; /* Flexbox for button alignment */\n    justify-content: flex-end; /* Aligns button to the right */\n}\n\n.modifier-button {\n    padding: 10px 20px; /* Add padding for better button size */\n    background-color: #007BFF; /* Button background color */\n    color: white; /* Button text color */\n    border: none; /* Remove default border */\n    border-radius: 5px; /* Rounded corners */\n    cursor: pointer; /* Pointer cursor on hover */\n    font-size: 16px; /* Font size */\n}\n\n.profile-logout-button {\n    padding: 10px 20px; /* Add padding for better button size */\n    background-color: red; /* Button background color */\n    color: white; /* Button text color */\n    border: none; /* Remove default border */\n    border-radius: 5px; /* Rounded corners */\n    cursor: pointer; /* Pointer cursor on hover */\n    font-size: 16px; /* Font size */\n}\n\n.dropdown-content {\n\n}\n\n.button-container {\n    display: flex; /* Flexbox for button alignment */\n    justify-content: flex-end; /* Align buttons to the right */\n    gap: 10px; /* Space between buttons */\n}\n\n.annuler-button {\n    padding: 10px 20px; /* Add padding for better button size */\n    background-color: red; /* Red background for Annuler */\n    color: white; /* White text color */\n    border: none; /* Remove default border */\n    border-radius: 5px; /* Rounded corners */\n    cursor: pointer; /* Pointer cursor on hover */\n    font-size: 16px; /* Font size */\n}\n\n.modifier-button {\n    padding: 10px 20px; /* Add padding for better button size */\n    background-color: #007BFF; /* Button background color */\n    color: white; /* Button text color */\n    border: none; /* Remove default border */\n    border-radius: 5px; /* Rounded corners */\n    cursor: pointer; /* Pointer cursor on hover */\n    font-size: 16px; /* Font size */\n}\n\n.info-row input {\n    margin-left: 10px; /* Add space between label and input */\n    padding: 5px; /* Add padding for better input appearance */\n    border: 1px solid #ccc; /* Border for the input */\n    border-radius: 5px; /* Rounded corners */\n    color: black; /* Text color */\n    background-color: white; /* Background color */\n}\n\n.lastActivitySideBar {\n    height: 100%;\n    width: 100%;\n    max-width: 312px;\n    background-color: #333333;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    padding-top: 54px;\n    padding-right: 24px;\n    padding-left: 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    color: white;\n    margin-left: 44px;\n\n\n}\n\n.lastActivityTitle{\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n\n.lastActivitySideBar ul {\n    list-style-type: none; /* Remove default bullets */\n    padding: 0; /* Remove default padding */\n    margin: 0; /* Remove default margin */\n  }\n  \n  .lastActivitySideBar li {\n    position: relative; /* Positioning for the bar */\n    padding-left: 20px; /* Space for the bar */\n    margin-bottom: 10px; /* Space between list items */\n  }\n  \n  .lastActivitySideBar li:before {\n    content: \"\"; /* Create a pseudo-element for the bar */\n    position: absolute; /* Position it absolutely */\n    left: 0; /* Align it to the left */\n    top: 0; /* Start from the top */\n    height: 100%; /* Full height of the list item */\n    width: 1px; /* Width of the bar */\n    background-color: white; /* Color of the bar */\n  }\n  \n  .lastActivitySideBar li:after {\n    content: \"\"; /* Create a pseudo-element for the dot */\n    position: absolute; /* Position it absolutely */\n    left: -3px; /* Align it to the left of the bar */\n    top: 0; /* Align it to the top of the list item */\n    width: 8px; /* Width of the dot */\n    height: 8px; /* Height of the dot */\n    background-color: white; /* Color of the dot */\n    border-radius: 50%; /* Make it circular */\n  }\n  \n  .date-text {\n    font-size: 12px; /* Adjust size as needed */\n    color: #8f8f8f; /* Optional: change color for the date */\n  }\n\n  @media (min-width: 1440px) {\n\n  }\n  \n  /* Tablettes et petits ordinateurs (jusqu'à 1024px) */\n  @media (max-width: 1024px) {\n  \n  }\n  \n  /* Tablettes en mode portrait et smartphones en paysage (jusqu'à 768px) */\n  @media (max-width: 768px) {\n  \n  }\n  \n  /* Smartphones en portrait (jusqu'à 480px) */\n  @media (max-width: 480px) {\n    .lastActivitySideBar {\n      display: none;\n    }\n    .profile-container {\n        margin-right: 42px;\n        width: 100%; /* Ensure it takes the full width */\n        overflow-y: auto; /* Add vertical scroll if the content exceeds screen height */\n        height: 85vh; /* Set the height to the viewport height to make it scrollable */\n        // padding-left: 20px;\n        // padding-right: 20px; /* Adjust padding for smaller screen */\n        // padding-bottom: 20px;\n        // margin-bottom: 20px;\n      }\n    .info-row{\n        display: block;\n    }\n  }\n\n  .langue-container {\n    display: flex; /* Use flexbox for layout */\n    justify-content: space-between; /* Space between 'langue :' and flags */\n    align-items: center; /* Align vertically to the center */\n    width: 100%; /* Ensure it takes the full width of the parent container */\n  }\n  \n  .langue-flags {\n    display: flex; /* Display flags in a row */\n    gap: 10px; /* Space between flags */\n  }\n  \n  .flag-icon {\n    width: 24px; /* Flag size */\n    height: 24px;\n    border-radius: 50%; /* Optional: Make flags circular */\n    object-fit: cover; /* Ensure flags fit properly */\n    cursor: pointer; /* Pointer cursor for interactivity */\n    transition: transform 0.2s; /* Hover effect */\n  }\n  \n  .flag-icon:hover {\n    transform: scale(1.1); /* Slightly enlarge on hover */\n  }\n  \n\n  .twofa-container {\n    display: flex; /* Use flexbox for layout */\n    justify-content: space-between; /* Space between '2FA' and buttons */\n    align-items: center; /* Align vertically to the center */\n    width: 100%; /* Ensure it takes the full width of the parent container */\n    margin-top: 2%;\n  }\n  \n  .twofa-options {\n    display: flex; /* Display buttons in a row */\n    gap: 10px; /* Space between buttons */\n  }\n  \n  .twofa-button {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 16px;\n    color: white;\n    background-color: #007BFF; /* Default blue for enabled state */\n    transition: background-color 0.3s ease;\n  }\n  \n  .twofa-button.disable {\n    background-color: #FF4B4B; /* Red for disabled state */\n  }\n  \n  .twofa-button:hover {\n    opacity: 0.9;\n  }\n  \n","$background-color-dark: #222222; // Main dark background\n$background-color-medium: #333333; // Slightly lighter background for elements\n$background-color-button: #007BFF; // Button color updated\n$text-color-light: white; // Light text for dark backgrounds\n$text-color-button: white; // Button text color\n\n.page {\n  background-color: $background-color-dark;\n  height: 100vh;\n  margin: 0;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: $text-color-light;\n  overflow-y: auto;\n}\n\n.title {\n  font-size: 2rem;\n  font-weight: bold;\n  margin: 2% 0 20px;\n}\n\n.txt {\n  font-size: 1rem;\n  margin: 4% 0 10px;\n}\n\n.txtBis {\n  font-size: 1rem;\n  margin: 1% 0 20px;\n}\n\n.subscription-container {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap; // Allow subscriptions to wrap onto new lines on smaller screens\n  width: 100%;\n}\n\n.subscription {\n  background-color: $background-color-medium;\n  margin: 10px;\n  padding: 20px;\n  border-radius: 10px;\n  text-align: center;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  max-width: 300px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 300px;\n\n  &.selected {\n    background-color: lighten($background-color-medium, 10%);\n  }\n\n  &.slide-in-left {\n    animation: slide-in-left 1s ease-out;\n  }\n\n  &.slide-in-right {\n    animation: slide-in-right 1s ease-out;\n  }\n}\n\n.price {\n  font-size: 1.5rem;\n  margin: 10px 0 20px;\n}\n\n.divider {\n  width: 50%;\n  margin: auto;\n  margin-bottom: 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.advantages-container {\n  background-color: $background-color-medium;\n  padding: 20px;\n  border-radius: 10px;\n  text-align: center;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  max-width: 300px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.button {\n  background-color: $background-color-button;\n  border: none;\n  color: $text-color-button;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 10px;\n  margin-right: 5px;\n\n  &:hover {\n    background-color: darken($background-color-button, 10%);\n  }\n}\n\n.confirm-button {\n  display: flex;\n  justify-content: flex-end;\n  font-size: 1rem;\n  padding: 10px 20px;\n  background-color: $background-color-button;\n  color: $text-color-button;\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s, box-shadow 0.3s;\n\n  &:hover {\n    background-color: darken($background-color-button, 10%);\n  }\n}\n\n.cross-button {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  font-size: 1.5rem;\n  cursor: pointer;\n}\n\n@keyframes slide-in-right {\n  0% {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slide-in-left {\n  0% {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n// Media Queries for Responsiveness\n@media (max-width: 768px) {\n  .title {\n    font-size: 1.5rem;\n    margin: 2% 0 15px;\n  }\n\n  .txt {\n    font-size: 0.9rem;\n    margin: 4% 0 8px;\n  }\n\n  .txtBis {\n    font-size: 0.9rem;\n    margin: 1% 0 15px;\n  }\n\n  .subscription {\n    max-width: 250px;\n    margin: 10px;\n  }\n\n  .confirm-button {\n    font-size: 0.9rem;\n    padding: 8px 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .subscription {\n    max-width: 100%;\n    margin: 10px 0;\n  }\n\n  .txt {\n    font-size: 0.8rem;\n    margin: 3% 0 6px;\n  }\n\n  .txtBis {\n    font-size: 0.8rem;\n    margin: 1% 0 10px;\n  }\n\n  .confirm-button {\n    font-size: 0.8rem;\n    padding: 6px 12px;\n  }\n}\n",".login-box {\r\n  background-color: #333333;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0px 50px 20px 50px;\r\n  border-radius: 15px;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  width: 80%; /* Default width */\r\n  max-width: 400px; /* Ensures the login box doesn't grow too large */\r\n  margin: 0 auto; /* Centers the box horizontally */\r\n  }\r\n\r\n  .text-Connexion {\r\n    font-size: 24px;\r\n    color: white;\r\n  }\r\n  \r\n  .signup-button {\r\n    font-size: 13px;\r\n    background: none;\r\n    border: none;\r\n    color: #fff;\r\n    text-decoration: underline;\r\n    cursor: pointer;\r\n    font-size: inherit;\r\n    padding: 0;\r\n\r\n    &:hover {\r\n      color: #0056b3; /* Couleur au survol */\r\n    }\r\n  }\r\n\r\n  .signup-ForgetPassword {\r\n    font-size: 13px;\r\n    background: none;\r\n    border: none;\r\n    color: #fff;\r\n    cursor: pointer;\r\n    font-size: inherit;\r\n    padding: 0;\r\n\r\n    &:hover {\r\n      color: #0056b3; /* Couleur au survol */\r\n    }\r\n  }\r\n\r\n  .signup-text {\r\n    color: white;\r\n    size: 13px;\r\n    font-size: 13px;\r\n  }\r\n  \r\n  .signup-button:hover {\r\n    color: #ddd;\r\n  }\r\n\r\n/* styles.scss */\r\n.connect-button {\r\n  width: 400px;         /* Largeur du bouton */\r\n  height: 49px;         /* Hauteur fixe du bouton */\r\n  border-radius: 12px;  /* Bordures arrondies */\r\n  padding: 15px 20px;   /* Espacement interne (padding) */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  // gap: 10px;            /* Espacement entre les éléments internes */\r\n  background-color: #0E71D0;  /* Couleur de fond (bleu par exemple) */\r\n  color: white;         /* Couleur du texte */\r\n  font-size: 16px;      /* Taille du texte */\r\n  cursor: pointer;      /* Curseur pointeur au survol */\r\n  border: none;         /* Pas de bordure */\r\n  outline: none;        /* Pas de contour */\r\n  \r\n  &:hover {\r\n    background-color: #0056b3; /* Changement de couleur au survol */\r\n  }\r\n}\r\n\r\n@media (min-width: 1440px) {\r\n  .login-box {\r\n    padding: 40px; /* Reduce padding on smaller screens */\r\n  }\r\n  .connect-button {\r\n    // width: 450px;        /* Bouton plus large sur les grands écrans */\r\n    font-size: 18px;     /* Texte légèrement plus grand */\r\n    padding: 18px 24px;  /* Plus de padding pour un rendu plus espacé */\r\n  }\r\n  }\r\n\r\n/* Tablettes et petits ordinateurs */\r\n@media (max-width: 1024px) {\r\n  .login-box {\r\n    width: 70%;\r\n  }\r\n.connect-button{\r\n  width: 300px;        /* Réduction de la largeur pour les tablettes */\r\n  font-size: 16px;     /* Taille du texte standard */\r\n  padding: 14px 18px; \r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .login-box {\r\n    padding: 30px; /* Reduce padding on smaller screens */\r\n    width: 60%;\r\n  }\r\n  .connect-button{\r\n    // width: 300px;        /* Réduction supplémentaire pour les tablettes en portrait */\r\n    font-size: 15px;     /* Texte plus petit */\r\n    padding: 12px 16px;  \r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .login-box {\r\n    padding: 20px;\r\n    width: 70%;\r\n  }\r\n  .connect-button{\r\n    width: 100%;         /* Utilisation complète de la largeur de l'écran */\r\n    font-size: 14px;     /* Taille du texte réduite pour s'adapter aux petits écrans */\r\n    padding: 10px 12px;  /* Padding plus réduit pour un design plus compact */\r\n    height: 44px;        \r\n  }\r\n}\r\n\r\n/* Modal overlay */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.8); /* Transparent black background */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000; /* Ensure the modal is on top */\r\n}\r\n\r\n/* Modal content */\r\n.modal-content {\r\n  background-color: #333333; /* Dark background */\r\n  padding: 15px 20px; /* Reduced padding for a smaller height */\r\n  border-radius: 15px;\r\n  width: 90%;\r\n  max-width: 400px;\r\n  text-align: center;\r\n  color: white; /* White text for contrast */\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px; /* Reduced space between elements */\r\n  justify-content: center; /* Center the content vertically */\r\n  align-items: center; /* Center the content horizontally */\r\n  max-height: 400px; /* Limit the height of the modal */\r\n  overflow-y: auto; /* Allow scrolling if content exceeds height */\r\n}\r\n\r\n/* Logo in the modal */\r\n.modal-logo {\r\n  max-width: 80px; /* Reduce the logo size */\r\n  margin-bottom: 10px; /* Reduce space below the logo */\r\n}\r\n\r\n/* Modal input fields */\r\n.modal-content .input {\r\n  margin-bottom: 15px;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  border: 1px solid #ccc;\r\n  font-size: 14px;\r\n  width: 100%; /* Make inputs full-width */\r\n}\r\n\r\n.modal-content .connect-button {\r\n  background-color: #0E71D0; /* Blue background */\r\n  color: white;\r\n  font-size: 16px;\r\n  padding: 12px 20px;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  border: none;\r\n  outline: none;\r\n  width: 100%;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.modal-content .connect-button:hover {\r\n  background-color: #0056b3; /* Darker blue on hover */\r\n}\r\n\r\n/* Close button */\r\n.close-modal-button {\r\n  background-color: #999999; /* Gray button for closing */\r\n  color: white;\r\n  font-size: 16px;\r\n  padding: 12px 20px;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  border: none;\r\n  outline: none;\r\n  width: 100%;\r\n}\r\n\r\n.close-modal-button:hover {\r\n  background-color: #666666; /* Darker gray on hover */\r\n}\r\n\r\n// .login-box {\r\n//   width: 300px;\r\n//   margin: 0 auto;\r\n//   text-align: center;\r\n// }\r\n\r\n.input {\r\n  width: 100%;\r\n  padding: 10px;\r\n  margin: 10px 0;\r\n  font-size: 16px;\r\n}\r\n\r\n.password-requirements {\r\n  text-align: left;\r\n  padding: 0;\r\n  list-style-type: none;\r\n}\r\n\r\n.password-requirements li {\r\n  font-size: 14px;\r\n  margin: 5px 0;\r\n}\r\n\r\n.password-requirements li.valid {\r\n  color: green;\r\n}\r\n\r\n.password-requirements li.invalid {\r\n  color: red;\r\n}\r\n\r\n.connect-button {\r\n  width: 100%;\r\n  padding: 10px;\r\n  font-size: 16px;\r\n  margin-top: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.connect-button:disabled {\r\n  background-color: #ccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.error-message {\r\n  color: red;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.inputs-container {\r\n  // max-height: 150px; /* Height to display only 3 inputs */\r\n  // overflow-y: auto; /* Enable scrolling for remaining inputs */\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px; /* Space between inputs */\r\n}\r\n\r\n\r\n@media (max-width: 376px) {\r\n  .login-box {\r\n    max-height: 90vh; /* Limit the height to fit within the viewport */\r\n    overflow-y: auto; /* Enable vertical scrolling */\r\n    padding: 10px; /* Reduce padding for smaller screens */\r\n    width: 90%; /* Adjust width for better fit */\r\n  }\r\n\r\n  .inputs-container {\r\n    max-height: none; /* Remove height limit for smaller screens */\r\n    overflow-y: visible; /* Ensure inputs are fully visible */\r\n  }\r\n\r\n  .connect-button {\r\n    font-size: 14px; /* Smaller text for smaller screens */\r\n    padding: 8px 10px; /* Compact padding */\r\n    width: 100%; /* Full width */\r\n  }\r\n}\r\n\r\n.scrollable-container {\r\n  max-height: 400px; /* Adjust this height to fit your design */\r\n  overflow-y: auto;  /* Enable vertical scrolling */\r\n  width: 100%;\r\n}",".input {\r\n    border-radius: 15px;\r\n    padding-top: 14px;\r\n    padding-right: 20px;\r\n    padding-bottom: 14px;\r\n    padding-left: 20px;\r\n    background-color: #e7e7e8;\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%; /* On utilise 100% par défaut pour une meilleure adaptabilité */\r\n    box-sizing: border-box;\r\n    border: 1px solid #ccc;\r\n    font-size: 16px;\r\n    outline: none;\r\n    max-width: 400px; /* Largeur maximale pour les grands écrans */\r\n    height: 48px;\r\n}\r\n\r\n/* Grands écrans (à partir de 1440px) */\r\n@media (min-width: 1440px) {\r\n    .input {\r\n        max-width: 500px; /* Augmentation de la largeur pour les grands écrans */\r\n        font-size: 18px; /* Texte légèrement plus grand */\r\n        padding: 16px 24px; /* Plus de padding pour plus de confort visuel */\r\n    }\r\n}\r\n\r\n/* Tablettes et petits ordinateurs (jusqu'à 1024px) */\r\n@media (max-width: 1024px) {\r\n    .input {\r\n        max-width: 300px; /* Réduction de la largeur pour s'adapter aux tablettes */\r\n        font-size: 16px; /* Taille de texte légèrement réduite */\r\n    }\r\n}\r\n\r\n/* Tablettes en mode portrait et smartphones en paysage (jusqu'à 768px) */\r\n@media (max-width: 768px) {\r\n    .input {\r\n        // max-width: 300px; /* Encore moins large pour les tablettes en portrait */\r\n        font-size: 15px; /* Texte plus petit */\r\n    }\r\n}\r\n\r\n/* Smartphones en portrait (jusqu'à 480px) */\r\n@media (max-width: 480px) {\r\n    .input {\r\n        max-width: 100%; /* Utilisation complète de la largeur de l'écran */\r\n        font-size: 14px; /* Taille de texte réduite pour les petits écrans */\r\n        height: 44px; /* Hauteur réduite pour économiser de l'espace */\r\n        padding: 12px 16px; /* Moins de padding pour un design plus compact */\r\n    }\r\n}\r\n",".resend-button {\r\n    font-size: 15px;\r\n    background: none;\r\n    border: none;\r\n    color: #fff;\r\n    text-decoration: underline;\r\n    cursor: pointer;\r\n    font-size: inherit;\r\n    padding: 0;\r\n\r\n    &:hover {\r\n        color: #0056b3;\r\n        /* Couleur au survol */\r\n    }\r\n}\r\n\r\n.resend-text {\r\n    color: white;\r\n    font-size: 15px;\r\n    word-wrap: break-word;\r\n    /* Permet au texte de se couper s'il est trop long */\r\n    line-height: 1.5;\r\n    /* Espace entre les lignes */\r\n    margin-bottom: 15px;\r\n}","/* Styles pour le conteneur d'entrée du code */\r\n.code-input-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 10px;\r\n    /* Espacement entre chaque boîte */\r\n    margin-bottom: 20px;\r\n}\r\n\r\n/* Style des boîtes d'entrée */\r\n.code-input-box {\r\n    width: 50px;\r\n    height: 50px;\r\n    text-align: center;\r\n    font-size: 24px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 8px;\r\n    box-sizing: border-box;\r\n    outline: none;\r\n}\r\n\r\n.code-input-box:focus {\r\n    border-color: #007bff;\r\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\r\n}\r\n\r\n/* Style pour le bouton */\r\nbutton {\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n    border-radius: 8px;\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    cursor: pointer;\r\n}\r\n\r\nbutton:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .code-input-box {\r\n        width: 30px;\r\n        height: 30px;\r\n  }\r\n}","/* Sidebar container */\r\n.sidebar {\r\n  display: flex;\r\n  flex-direction: column; /* Stack items vertically */\r\n  justify-content: space-between; /* Push content to edges */\r\n  height: 100%; /* Full height */\r\n  background-color: #1C1C1C;\r\n  color: white;\r\n  padding-top: 40px;\r\n  padding-left: 16px;\r\n  padding-right: 16px;\r\n}\r\n\r\n/* Logo styling */\r\n.logo {\r\n  text-align: center;\r\n\r\n  .logo-image {\r\n    width: 200px;\r\n    height: auto;\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n\r\n.logo-btn{\r\n  background-color: transparent;\r\n}\r\n.logo-btn:hover {\r\n  background-color: transparent; /* Ensures the background remains the same on hover */\r\n  cursor: default; /* Optional: Change the cursor to default on hover */\r\n}\r\n\r\n/* Navigation links */\r\n.nav-links {\r\n  list-style: none;\r\n  padding: 0;\r\n  width: 100%;\r\n\r\n  li {\r\n    width: 100%;\r\n    margin-bottom: 20px;\r\n\r\n    .nav-button {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: flex-start;\r\n      width: 100%;\r\n      padding: 15px;\r\n      background: none;\r\n      border: none;\r\n      color: white; /* Default text color */\r\n      text-align: left;\r\n      font-size: 16px;\r\n      cursor: pointer;\r\n      transition: background 0.3s;\r\n\r\n      img {\r\n        margin-right: 10px;\r\n        width: 24px;\r\n        height: 24px;\r\n        filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%); /* Default icon color (#333333) */\r\n      }\r\n\r\n      &:hover {\r\n        background-color: #444;\r\n      }\r\n\r\n      &.active {\r\n        background-color: #333; /* Fond pour le bouton actif */        \r\n      }\r\n\r\n    }\r\n  }\r\n}\r\n\r\n/* Divider */\r\n\r\n\r\n\r\n.sidebar-divider {\r\n  width: 228px;\r\n  border: 1px solid rgba(151, 151, 151, 0.3);\r\n  /* Couleur et opacité de la ligne */\r\n  padding-top: 40px 0;\r\n  /* Espace autour de la ligne */\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media screen and (max-width: 768px) {\r\n  .sidebar {\r\n    display: none; /* Hide sidebar below 768px */\r\n  }\r\n\r\n  .mobile-nav {\r\n    display: flex; /* Show mobile nav at 768px and below */\r\n  }\r\n}\r\n\r\n\r\n@media (min-width: 1440px) {\r\n\r\n}\r\n\r\n/* Tablettes et petits ordinateurs (jusqu'à 1024px) */\r\n@media (max-width: 1024px) {\r\n  .sidebar {\r\n    // width: 150px;\r\n\r\n    .logo-image {\r\n      width: 80px;\r\n    }\r\n  }\r\n\r\n  .sidebar-divider {\r\n    width: 130px;\r\n  }\r\n}\r\n\r\n\r\n\r\n.mobile-nav {\r\n  display: none; /* Hidden by default */\r\n  position: fixed;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  background-color: #1C1C1C;\r\n  display: flex;\r\n  justify-content: space-around;\r\n  padding: 5px 0; /* Reduce padding to fit buttons */\r\n  z-index: 1000;\r\n  overflow-x: auto; /* Allow horizontal scrolling if needed */\r\n}\r\n\r\n.mobile-nav button {\r\n  background: none;\r\n  border: none;\r\n  color: white;\r\n  text-align: center;\r\n  flex-direction: column; /* Stack icon and text vertically */\r\n  display: flex;\r\n  align-items: center; /* Center align items */\r\n  flex-grow: 1; /* Allow buttons to take equal width */\r\n  padding: 5px; /* Reduce padding to fit more buttons */\r\n}\r\n\r\n.mobile-nav img {\r\n  width: 20px; /* Smaller icons */\r\n  height: 20px;\r\n  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);\r\n}\r\n\r\n.mobile-nav span {\r\n  font-size: 10px; /* Smaller text */\r\n  margin-top: 2px; /* Less space between icon and text */\r\n  color: #999; /* Lighter text color */\r\n}\r\n\r\n/* Media query for phones (less than 480px) */\r\n@media (max-width: 480px) {\r\n  .sidebar {\r\n    display: none; /* Hide the sidebar on phones */\r\n  }\r\n\r\n  .mobile-nav {\r\n    display: flex; /* Show the mobile nav only on phones */\r\n  }\r\n}\r\n\r\n\r\n@media (min-width: 769px) {\r\n  .mobile-nav {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Media queries for larger screens (tablet and desktop) */\r\n// @media (min-width: 481px) {\r\n//   .mobile-nav {\r\n//     display: none; /* Ensure mobile nav is hidden for screens above 480px */\r\n//   }\r\n// }\r\n\r\n// @media (max-width: 480px) {\r\n//   .sidebar {\r\n//     width: 100%; /* Full width for mobile */\r\n//     height: auto; /* Height will depend on content */\r\n//     position: fixed; /* Fix position to the bottom */\r\n//     bottom: 0; /* Align to the bottom */\r\n//     left: 0; /* Align to the left */\r\n//     flex-direction: row; /* Change to row for horizontal layout */\r\n//     justify-content: space-around; /* Distribute space between items */\r\n//     padding: 10px 0; /* Adjust padding for mobile */\r\n//   }\r\n  \r\n//   /* Adjusting nav links for mobile */\r\n//   .nav-links {\r\n//     display: flex; /* Flex display for horizontal layout */\r\n//     flex-direction: row; /* Row layout */\r\n//     justify-content: space-around; /* Evenly space items */\r\n//     width: 100%; /* Full width */\r\n//   }\r\n\r\n//   .nav-button {\r\n//     flex: 1; /* Allow buttons to grow */\r\n//     text-align: center; /* Center text */\r\n//   }\r\n  \r\n//   .logo {\r\n//     display: none; /* Hide logo on mobile for space */\r\n//   }\r\n// }\r\n\r\n.logout-button {\r\n  margin-top: auto; /* Pushes the button to the bottom */\r\n  padding: 15px;\r\n  background-color: #e53935; /* Red color */\r\n  color: white;\r\n  font-size: 16px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  transition: background-color 0.3s;\r\n  margin-bottom: 20px;\r\n  display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n}\r\n\r\n.logout-button:hover {\r\n  background-color: #c62828; /* Darker red on hover */\r\n}\r\n\r\n// .mobile-nav button:last-child {\r\n//   color: #e53935; /* Highlight logout button */\r\n//   font-size: 10px; /* Smaller text */\r\n//   margin-top: 2px; /* Less space between icon and text */\r\n// }\r\n\r\n.logout-icon {\r\n  width: 20px; /* Icon size */\r\n  height: 20px;\r\n  margin-right: 10px;\r\n  filter: invert(1);\r\n}",".DocumentSideBar {\r\n  height: 100%;\r\n  width: 100%;\r\n  max-width: 312px;\r\n  background-color: #333333;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  padding-top: 54px;\r\n  padding-right: 24px;\r\n  padding-left: 24px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  color: white;\r\n}\r\n\r\n\r\n\r\n@media (min-width: 1440px) {\r\n\r\n}\r\n\r\n/* Tablettes et petits ordinateurs (jusqu'à 1024px) */\r\n@media (max-width: 1024px) {\r\n\r\n}\r\n\r\n/* Tablettes en mode portrait et smartphones en paysage (jusqu'à 768px) */\r\n@media (max-width: 768px) {\r\n\r\n}\r\n\r\n/* Smartphones en portrait (jusqu'à 480px) */\r\n@media (max-width: 480px) {\r\n  .DocumentSideBar {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.divider-document {\r\n  width: 100%;\r\n  border: 1px solid rgba(151, 151, 151, 0.3);\r\n  margin-bottom: 0px;\r\n}\r\n\r\n\r\n.quickAccess {\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n  line-height: 32.74px;\r\n  color: white;\r\n}\r\n\r\n.documentList {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  scrollbar-width: none; /* Firefox */\r\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\r\n  overflow-y: auto;\r\n}\r\n\r\n.documentItem {\r\n  background-color: #222222; /* Couleur de fond */\r\n  border-radius: 10px; /* Rayon des coins */\r\n  padding: 15px; /* Padding interne */\r\n  display: flex;\r\n  justify-content: space-between; /* Sépare le texte à gauche et l'étoile à droite */\r\n  align-items: center; /* Centre verticalement les éléments */\r\n  color: white; /* Couleur du texte pour qu'il soit visible sur fond sombre */\r\n  margin-bottom: 15px; /* Espace entre chaque item de fichier */\r\n}\r\n\r\n.documentInfo {\r\n  display: flex;\r\n  flex-direction: column; /* Permet d'afficher le nom au-dessus de la date */\r\n}\r\n\r\n.documentName {\r\n  font-size: 17px;\r\n  font-weight: bold;\r\n}\r\n\r\n.documentDate {\r\n  font-size: 14px;\r\n  color: #FFFFFF;\r\n  margin-top: 5px; /* Espace entre le nom et la date */\r\n  line-height: 19px;\r\n}\r\n\r\n.Favorite-container {\r\n  display: flex;\r\n  justify-content: center; /* Centrer le bouton horizontalement dans le conteneur */\r\n  align-items: center; /* Centrer le bouton verticalement dans le conteneur */\r\n}\r\n\r\n\r\n.favoriButton:hover {\r\n  background: none;\r\n}\r\n\r\n.containerwith-logo {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.documentIcon {\r\n  margin-right: 10px; /* Espace entre le logo et le texte */\r\n  align-self: flex-start; /* Aligne le logo en haut (pas centré) */\r\n}\r\n\r\n.favoriButton {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.favoriIcon {\r\n  width: 24px; /* Taille de l'icône */\r\n  height: 24px;\r\n  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);\r\n}\r\n\r\n.favoriButton:hover .favoriIcon {\r\n  filter: invert(1) brightness(0.8) saturate(100%); /* Effet au survol, légèrement moins blanc */\r\n}",".storageBox {\r\n  // width: 312px; // Largeur fixe\r\n  background-color: #222222; // Couleur de fond\r\n  border-radius: 10px; // Rayon des coins\r\n  padding: 40px; // Padding interne\r\n  gap: 20px; // Espacement entre les éléments à l'intérieur\r\n  flex-direction: column; // Pour que les éléments à l'intérieur s'alignent verticalement\r\n  display: flex;\r\n  color: white; // Couleur du texte pour qu'il soit visible sur fond sombre\r\n  position: relative; // Pour permettre l'usage de `top` sur les éléments internes\r\n}\r\n\r\n\r\n\r\n\r\n.storageText {\r\n  font-size: 20px; // Taille de la police pour le texte \"Stockage\"\r\n  color: white; // Texte blanc\r\n}\r\n\r\n.fileCount {\r\n  font-size: 17px; // Taille de la police pour le texte \"(nb) fichier(s)\"\r\n  color: white; // Texte blanc\r\n  position: relative;\r\n  top: 15px;\r\n}\r\n\r\n.storageBarContainer {\r\n  width: 100%; /* La barre occupe toute la largeur de son conteneur */\r\n  height: 17px;\r\n  background-color: #FFFFFF; /* Couleur de fond de la barre */\r\n  border-radius: 100px;\r\n  overflow: hidden; /* Pour que le débordement du contenu soit masqué */\r\n}\r\n\r\n.storageBar {\r\n  height: 100%;\r\n  background:#0E71D0 100%;\r\n  border-radius: 100px;\r\n  width: 0%; /* La largeur sera ajustée dynamiquement */\r\n  transition: width 0.3s ease-in-out; /* Animation douce pour la mise à jour du pourcentage */\r\n}\r\n\r\n.storageInfo {\r\n  display: flex;\r\n  justify-content: space-between; /* Permet de les séparer ou utiliser 'flex-start' pour les aligner à gauche */\r\n}\r\n\r\n.textButton {\r\n  background: none;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n  font-size: 16px; /* Taille du texte */\r\n  padding: 0; /* Enlever le padding par défaut */\r\n  align-self: flex-start; /* Cette propriété permet de l'aligner à gauche dans un conteneur flex */\r\n}\r\n\r\n.textButton:hover {\r\n  background: none;\r\n  color: #0056b3; /* Changement de couleur au survol */\r\n  text-decoration: none; /* Enlever le soulignement au survol */\r\n}\r\n\r\n.modalOverlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n\r\n.modalContent {\r\n  width: 80%; /* Default width */\r\n  max-width: 600px; /* Limit the modal size */\r\n  max-height: 80vh; /* Adjust height based on content */\r\n  // max-height: auto; /* Prevent overflow */\r\n  background: #333333;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  position: relative;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n  color: white;\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center; /* Horizontally center */\r\n  // justify-content: center; /* Vertically center */\r\n  overflow-y: auto; /* Enable scrolling if content exceeds height */\r\n}\r\n\r\n.closeIcon {\r\n  position: absolute;\r\n  top: 10px;\r\n  left: 10px;\r\n  width: 24px;\r\n  height: 24px;\r\n  cursor: pointer;\r\n}\r\n\r\n.modalContent h2 {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.modalContent p {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n@media (min-width: 1440px) {\r\n\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .storageBox {\r\n    width: 200px;\r\n  }\r\n  .modalContent {\r\n    width: 90%; /* Adjust modal width */\r\n    max-width: 500px;\r\n    padding: 15px; /* Reduce padding */\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .storageBox {\r\n    width: 200px;\r\n  }\r\n  .modalContent {\r\n    width: 95%; /* Almost full width */\r\n    max-width: 400px;\r\n    padding: 10px;\r\n  }\r\n  .modalContent h2 {\r\n    font-size: 18px; /* Adjust header size */\r\n  }\r\n\r\n  .modalContent p {\r\n    font-size: 14px; /* Adjust paragraph size */\r\n  }\r\n\r\n  .closeIcon {\r\n    top: 5px;\r\n    right: 5px;\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n}\r\n\r\n// @media (max-width: 480px) {\r\n//   .modalContent {\r\n//     width: 95%; /* Almost full screen width */\r\n//     max-width: 95%;\r\n//     height: auto;\r\n//     padding: 15px;\r\n//     border-radius: 4px; /* Smaller border radius */\r\n//   }\r\n\r\n//   .modalContent h2 {\r\n//     font-size: 16px; /* Adjust title size */\r\n//   }\r\n\r\n//   .modalContent p {\r\n//     font-size: 14px; /* Adjust paragraph size */\r\n//   }\r\n\r\n//   .closeIcon {\r\n//     top: 5px;\r\n//     right: 5px;\r\n//     width: 18px;\r\n//     height: 18px;\r\n//   }\r\n// }",".offer-Container {\r\n    background-color: #333333;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n    padding-top: 40px;\r\n    padding-bottom: 40px;\r\n    border-radius: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    /* Pour espacer les flèches et le texte */\r\n    gap: 20px;\r\n    /* Espace entre les éléments */\r\n    color: white;\r\n    /* Texte en blanc */\r\n}\r\n\r\n.arrow-button {\r\n    background-color: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 0px;\r\n}\r\n\r\n.arrow-button:hover {\r\n    background-color: transparent;\r\n    color: #222222;\r\n}\r\n\r\n.offer-text {\r\n    flex-grow: 1;\r\n    font-size: 20px;\r\n    line-height: 27px;\r\n}\r\n\r\n.offer-box {\r\n    gap: 12px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start; \r\n}\r\n\r\n.discover-button {\r\n    background-color: #007BFF;\r\n    color: white;\r\n    padding: 15px 20px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n@media (max-width: 475px) {\r\n    .offer-Container{\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n",".index-scenario-main-page {\n    height: 100%;\n    width: 100%;\n    display: flex;\n}\n.scenarios-container {\n    flex-grow: 1;           /* Allow it to grow and fill the available space */\n    overflow-y: auto;      /* Enable vertical scrolling */\n    max-height: calc(100vh - 100px); /* Adjust max height based on header/button height */\n}\n\n.index-scenario-page {\n    height: 100%;\n    gap: 44px;\n    width: 100%;\n    padding-left: 42px;\n    padding-right: 42px;\n    padding-top: 32px;\n    flex-direction: column;\n    display: flex;\n    color: white;\n}\n\n.index-scenario-top-page {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.index-scenario-add-button {\n    background-color: #007BFF;\n    color: white;\n    padding: 15px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-left: 10px;\n}\n\n.index-scenario-add-button:hover {\n    background-color: #0056b3;\n}\n\n/* Existing styles here... */\n\n/* Grid layout for the cards */\n.card-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));  /* Automatically adjust to fit */\n    gap: 40px;\n    margin-bottom: 80px;\n    justify-content: center; /* Ensure the cards are centered */\n}\n\n/* Card container */\n.card-scenario {\n    width: 100%; /* Make the card width responsive */\n    max-width: 532px; /* Maximum width for larger screens */\n    background-color: #2e2e2e; /* Dark background */\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n// hidden when the img is too big\n// .card-image {\n//     width: 100%;\n//     height: 200px; /* Set a fixed height */\n//     overflow: hidden; /* Hide overflow in case image aspect ratio is different */\n// }\n\n// /* Card image */\n// .card-image img {\n//     border-radius: 10px 10px 0 0;\n//     width: 100%;\n//     height: auto; /* Ensure the height adjusts with width */\n//     object-fit: cover; /* Maintain aspect ratio */\n// }\n\n\n\n.card-image {\n    width: 100%;\n    height: 200px; /* Set a fixed height */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #f0f0f0; /* Optional: add a background color for images that don't fill the area */\n}\n\n.card-image img {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain; /* Ensure the image fits within the dimensions and maintains aspect ratio */\n    // border-radius: 10px 10px 0 0;\n}\n\n/* Card content (title and description) */\n.card-content {\n    padding: 16px;\n    color: #fff;\n    flex-grow: 1; /* Allow content to fill remaining space */\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start; /* Align items at the start */\n}\n\n/* Title and paragraph styling */\n.card-content h3 {\n    margin: 0; /* Remove default margin */\n    font-size: 1.25em;\n}\n\n.card-content p {\n    margin: 8px 0 0; /* Add margin for spacing */\n    font-size: 0.9em;\n    color: #a0a0a0;\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n    /* For tablets and smaller devices */\n    .card-grid {\n        grid-template-columns: 1fr; /* 1 card per row */\n    }\n\n    .card-scenario {\n        margin: 0 auto; /* Center the card */\n        width: 90%; /* Adjust width */\n        max-width: none; /* Remove max-width to allow more flexibility */\n    }\n\n    .card-content h3 {\n        font-size: 1.1em; /* Reduce font size for smaller screens */\n    }\n\n    .card-content p {\n        font-size: 0.85em; /* Reduce font size for smaller screens */\n    }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n    /* For small laptops */\n    .card-grid {\n        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); /* Adjust to fill available space */\n    }\n}\n\n@media (min-width: 1025px) {\n    /* For larger screens */\n    .card-grid {\n        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)); /* Adjust to fill available space */\n    }\n}\n\n\n.scenarioDetail-delete-button {\n    background-color: #FF4B4B; /* Red color */\n    color: white;\n    border: none;\n    border-radius: 8px;\n    padding: 10px 20px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: bold;\n    transition: background-color 0.3s ease;\n  }\n  \n  .scenarioDetail-delete-button:hover {\n    background-color: #D94444; /* Slightly darker red for hover effect */\n    opacity: 0.9;\n  }",".scenarioDetail-main-page {\n    height: 100%;\n    width: 100%;\n    display: flex;\n  }\n  \n  .scenarioDetail-page {\n    height: 100%;\n    gap: 44px;\n    width: 100%;\n    padding-left: 42px;\n    padding-right: 42px;\n    padding-top: 32px;\n    flex-direction: column;\n    display: flex;\n    color: white;\n  }\n  \n  .scenarioDetail-top-page {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .left-side {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .right-side {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  /* For the document container */\n  .scenario-detail-document-container {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 10px;\n  }\n  \n  .document-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #2A2A2A;\n    border-radius: 10px;\n    padding: 20px;\n  }\n  \n  .document-text {\n    display: flex;\n    flex-direction: column;\n    color: white;\n  }\n  \n  .document-title {\n    font-size: 16px;\n    font-weight: bold;\n  }\n  \n  .document-description {\n    font-size: 14px;\n    color: #888888;\n  }\n  \n  /* Status styles */\n  .document-status {\n    // display: flex;\n    // align-items: center;\n  }\n  \n  .valid {\n    background-color: #37A169;\n    color: white;\n    padding: 8px 16px;\n    border-radius: 12px;\n  }\n  \n  .scenario-detail-upload-button {\n    background-color: #007BFF;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 12px;\n    cursor: pointer;\n  }\n  \n  .scenario-detail-upload-button:hover {\n    background-color: #0056b3;\n  }\n  .scenarioDetail-add-button {\n    background-color:#37A169;\n    color: white;\n    padding: 15px 20px;\n    border: none;\n    border-radius: 12px;\n    cursor: pointer;\n    margin-left: 10px; /* Add some space between the buttons */\n  }\n  \n  .scenarioDetail-add-button:hover {\n    background-color: #37A169;\n  }\n\n  .scenarioDetail-add-button-dot {\n    background-color:#474747;\n    color: white;\n    padding: 15px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    border-radius: 12px;\n    margin-left: 10px; /* Add some space between the buttons */\n  } \n",".disclaimer-container {\n    background-color: #222222;\n    height: 100vh;\n    width: 100vw;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative; /* Ensure child elements like buttons are positioned relative to this */\n  }\n  \n  .language-buttons {\n    position: absolute;\n    top: 20px; /* Distance from the top */\n    right: 20px; /* Distance from the right */\n    display: flex;\n    gap: 10px;\n  }\n  \n  .language-button:hover {\n    background-color: #222222;\n  }\n  \n  .language-buttons:hover {\n    background-color: #222222;\n\n  }\n  \n  .language-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n  }\n\n\n  .language-button img {\n    width: 24px;\n    height: 24px;\n  }\n  \n  .disclaimer-image {\n    width: 150px;\n    margin-bottom: 20px;\n  }\n  \n  .disclaimer-box {\n    background-color: #333333;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 30px;\n    border-radius: 15px;\n    flex-direction: column;\n    gap: 20px;\n    width: 90%; /* Default width for smaller screens */\n    max-width: 720px;\n    margin: 0 auto;\n    text-align: center;\n  }\n  \n  .disclaimer-title {\n    font-size: 24px;\n    color: white;\n  }\n  \n  .disclaimer-text {\n    font-size: 12px;\n    color: white;\n    line-height: 1.5;\n  }\n  \n  /* Media queries */\n  @media (min-width: 768px) {\n    .disclaimer-box {\n      padding: 50px;\n      width: 70%;\n    }\n  \n    .disclaimer-image {\n      width: 200px;\n    }\n  \n    .disclaimer-title {\n      font-size: 28px;\n    }\n  \n    .disclaimer-text {\n      font-size: 16px;\n    }\n  }\n  \n  @media (min-width: 1024px) {\n    .disclaimer-box {\n      width: 720px;\n    }\n  \n    .disclaimer-title {\n      font-size: 32px;\n    }\n  \n    .disclaimer-text {\n      font-size: 18px;\n    }\n  }\n  ","*,\n*::before,\n*::after {\n  box-sizing: border-box; /* Ensures padding and borders are included in the width */\n}\n\n.Newscenario-main-page {\n  height: 100%;\n  display: flex;\n  flex-direction: column; /* Stack header and inputs vertically */\n  padding: 20px;\n}\n\n.Newscenarioheader {\n  display: flex;\n  justify-content: space-between; /* Distribute items evenly */\n  align-items: baseline;\n}\n\n.Newscenario-left-header {\n  display: flex;\n}\n\n.text-item {\n  color: white;\n}\n\n.text-item-header {\n  color: white;\n  margin-left: 10px;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.back-arrow {\n  width: 24px;\n  height: auto;\n}\n\n.check-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background-color: green;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.check-icon {\n  width: 16px;\n  height: auto;\n  filter: brightness(0) invert(1);\n}\n\n.Newscenario-form-container {\n    margin-top: 20px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 80%;\n  }\n\n.input-field, .dropdown-field {\n  width: 100%; /* Makes both elements take full width */\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 16px;\n  color: black;\n}\n\n.input-field::placeholder, .dropdown-field {\n  color: #aaa;\n}\n\n.plus-button {\n  width: 100%;\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.plus-icon {\n  width: 20px;\n  height: auto;\n}\n\n.back-button {\n    background: none;  /* Remove background */\n    border: none;  /* Remove border */\n    cursor: pointer;  /* Make it clickable */\n    padding: 0;  /* Remove padding */\n  }\n  \n  .back-arrow {\n    width: 24px; /* Adjust size as needed */\n    height: auto;\n  }\n\n\n\n  \n  .dropdown-checkbox-container {\n    display: flex;\n    align-items: center;\n    width: 100%; /* Full width to align with other inputs */\n    gap: 10px;\n  }\n  \n  .dropdown-field {\n    flex: 1; /* Allow dropdown to expand */\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 16px;\n    color: black;\n  }\n  \n  .checkbox-container {\n    display: flex;\n    align-items: center;\n  }\n  \n  .checkbox-input {\n    width: 24px;    /* Increase width */\n    height: 24px;   /* Increase height */\n    transform: scale(1.5);  /* Scale up the checkbox */\n    margin-right: 10px; /* Add some space from the dropdown */\n  }\n  .trash-button {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 5px;\n    border-radius: 4px; /* Optional: to give a rounded look on hover */\n  }\n  \n  .trash-button:hover {\n    background-color: red; /* Changes background to red on hover */\n  }\n  \n  .trash-icon {\n    width: 20px;\n    height: auto;\n    filter: brightness(0) invert(1);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
